// Supplemental translations for payment, lounge management, user info, and asset ledger detail UI.
// Keep placeholders such as {message}, {title}, {fee}, {days}, {id}, and {targetId} intact.
const domainSupplement = {
  "ru": {
    " · 만료됨": " · Истекло",
    "% · 하위에이전트": "% · суб-агенты",
    "(본인/직속 하위 에이전트의": "(Ваши/прямых суб-агентов",
    "(제목 없음)": "(без заголовка)",
    "+ 이미지": "+ Изображение",
    "+ 텍스트": "+ Текст",
    "0 이상 숫자를 입력하세요.": "Введите число 0 или больше.",
    "0보다 큰 금액을 입력하세요.": "Введите сумму больше 0.",
    "2차 비밀번호(선택)": "Вторичный пароль (необязательно)",
    "DB/API 기반 에이전트 유료 업로드 관리": "Управление платными загрузками агентов на базе DB/API",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "Сохраняются только текстовые/графические блоки без HTML.",
    "fee_percent (선택, %)": "fee_percent (необязательно, %)",
    "fee_percent(유저)": "fee_percent (пользователь)",
    "onCredit 콜백이 연결되어 있지 않습니다.": "Колбэк onCredit не подключен.",
    "onDebit 콜백이 연결되어 있지 않습니다.": "Колбэк onDebit не подключен.",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· Сервер повторно проверяет категорию/статус/стоимость/права.",
    "· 소속유저": "· назначенные пользователи",
    "개 · 남은 수량": "шт. · Осталось",
    "검색 (id / user_code / nickname / 메모)": "Поиск (id / user_code / nickname / заметка)",
    "게시일:": "Дата публикации:",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "Сумма платежного пункта должна быть целым числом больше 0.",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "Количество платежного пункта должно быть целым числом 0 или больше.",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "Количество нельзя сделать меньше уже проданного.",
    "결제 항목명을 입력하세요.": "Введите название платежного пункта.",
    "경로": "Путь",
    "계정의 정보를 수정합니다.": "Редактировать данные аккаунта.",
    "금액은 최소 50$ 이상 부터 가능합니다.": "Сумма должна быть не менее 50$.",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "История перемещения активов вашего аккаунта и прямых/косвенных подчиненных (агентов/пользователей). Можно искать с фильтрами.",
    "내 어카운트": "Мой аккаунт",
    "내 자산 0,000,000": "Мои активы 0,000,000",
    "닉네임": "Никнейм",
    "등록된 결제 옵션이 없습니다.": "Нет зарегистрированных вариантов оплаты.",
    "등록된 라운지 글이 없습니다.": "Нет зарегистрированных записей лаунжа.",
    "라운지 게시에 실패했습니다.\n{message}": "Не удалось опубликовать лаунж.\n{message}",
    "라운지 목록 불러오는 중...": "Загрузка списка лаунжа...",
    "라운지 목록을 불러오지 못했습니다.": "Не удалось загрузить список лаунжа.",
    "라운지 삭제에 실패했습니다.\n{message}": "Не удалось удалить запись лаунжа.\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "В деталях лаунжа отображается ввод количества по пунктам + кнопка оплаты.",
    "라운지 저장에 실패했습니다.\n{message}": "Не удалось сохранить лаунж.\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "Не удалось приостановить лаунж.\n{message}",
    "레이크백": "Рейкбэк",
    "를 색상별로 누적 표시)": " отображаются накопленно по цветам)",
    "만료일:": "Дата истечения:",
    "메모": "Заметка",
    "받는쪽 (to)": "Получатель (to)",
    "발생시각": "Время события",
    "보낸쪽 (from)": "Отправитель (from)",
    "복사 실패(브라우저 권한 확인)": "Не удалось скопировать (проверьте разрешения браузера)",
    "본문 내용을 입력하세요": "Введите содержимое",
    "본문 블록": "Блок содержимого",
    "본인 {id}": "Вы {id}",
    "비밀번호(미입력 시 변경 안 함)": "Пароль (оставьте пустым, чтобы не менять)",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "Для предотвращения ошибок рекомендуется начать еще раз после проверки.",
    "생성 (미체크 시 일반 유저 생성)": "Создать (если не отмечено, создается обычный пользователь)",
    "생성 실패: ": "Ошибка создания: ",
    "선택 입력": "Необязательный ввод",
    "세컨드 비밀번호(옵션)": "Вторичный пароль (опция)",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "Если адрес кошелька отличается от адреса отправки, вы можете потерять средства. Проверьте еще раз перед заявкой.",
    "송금 완료 후 해당 버튼을 눌러주세요.": "Нажмите эту кнопку после завершения перевода.",
    "수정 모드": "Режим редактирования",
    "신규 작성": "Новая запись",
    "썸네일 이미지": "Миниатюра",
    "업로드 URL을 받지 못했습니다.": "URL загрузки не получен.",
    "업로드 비용": "Стоимость загрузки",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "Стоимость загрузки {fee} USDT будет списана из UserDB.asset, публикация продлится {days} дней с даты оплаты. Опубликовать?",
    "업로드/게시": "Загрузить/опубликовать",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "Требуется подключение API блокировки/разблокировки агента.\n(Сейчас поддерживается только блокировка пользователей)",
    "예: 25": "Напр.: 25",
    "예: AGT3001 또는 user123": "Напр.: AGT3001 или user123",
    "오래된순": "Сначала старые",
    "유저코드": "Код пользователя",
    "이 노드의 기본 수수료 비율(%)": "Базовая ставка комиссии этого узла (%)",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "Удалить эту запись лаунжа?\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "Приостановить эту запись лаунжа?\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "Установить комиссии всех игроков под этим агентом сразу",
    "이미지 alt 텍스트": "Alt-текст изображения",
    "이미지 블록": "Блок изображения",
    "이미지 업로드 중...": "Загрузка изображения...",
    "이미지 업로드에 실패했습니다.": "Не удалось загрузить изображение.",
    "일": "дн.",
    "일 /": "дн. /",
    "일/": "дн./",
    "입력값을 확인해 주세요.": "Проверьте введенные значения.",
    "자산 으로 변환": "Конвертировать в активы",
    "자산 타입": "Тип актива",
    "작성": "Создать",
    "작성일:": "Дата создания:",
    "재게시": "Опубликовать снова",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Сохранение бесплатно; стоимость списывается из активов агента только при первой публикации.",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Сохранение бесплатно. Стоимость списывается из активов агента только при первой загрузке/публикации.",
    "적용": "Применить",
    "전체": "Все",
    "전체 상태": "Все статусы",
    "접기": "Свернуть",
    "정렬": "Сортировка",
    "정보 수정 실패": "Не удалось изменить информацию",
    "정보수정": "Редактировать информацию",
    "정상": "Нормально",
    "제거": "Удалить",
    "제목을 입력하세요": "Введите заголовок",
    "종료일": "Дата окончания",
    "중지": "Остановить",
    "중지됨": "Остановлено",
    "지갑 주소": "Адрес кошелька",
    "지급": "Выдать",
    "지급 (대상: {targetId})": "Выдать (цель: {targetId})",
    "차감": "Списать",
    "차감 (대상: {targetId})": "Списать (цель: {targetId})",
    "차단": "Заблокировать",
    "차단 해제": "Разблокировать",
    "차단됨": "Заблокирован",
    "처리 중...": "Обработка...",
    "초기화": "Сброс",
    "초안": "Черновик",
    "총": "Всего",
    "최근순": "Сначала новые",
    "출금하기": "Вывести",
    "충전 하기": "Пополнить",
    "카테고리": "Категория",
    "클릭 시 출금이 시작 됩니다.": "При нажатии начнется вывод.",
    "클릭하여 이미지 업로드": "Нажмите, чтобы загрузить изображение",
    "타입": "Тип",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "Тестовая транзакция начинается после отправки 0.01 USDT и проверки корректного депозита.",
    "텍스트 블록": "Текстовый блок",
    "판매": "Продажа",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Фронт-тест: обработка завершения перевода (до подключения backend)",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Фронт-тест: обработка начала вывода (до подключения backend)",
    "플레이어 수수료 설정": "Настройка комиссии игрока",
    "하위": "Дочерний",
    "하위 생성 (부모:": "Создать дочерний (родитель:",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "Мы не несем ответственности за сумму при этой ошибке, обязательно проверьте еще раз.",
    "확인용 테스트 거래 시작": "Начать тестовую транзакцию для проверки",
    "회원 정보 수정": "Редактировать данные участника",
  },
  "zh": {
    " · 만료됨": " · 已过期",
    "% · 하위에이전트": "% · 下级代理",
    "(본인/직속 하위 에이전트의": "（本人/直属下级代理的",
    "(제목 없음)": "（无标题）",
    "+ 이미지": "+ 图片",
    "+ 텍스트": "+ 文本",
    "0 이상 숫자를 입력하세요.": "请输入大于等于 0 的数字。",
    "0보다 큰 금액을 입력하세요.": "请输入大于 0 的金额。",
    "2차 비밀번호(선택)": "二级密码（可选）",
    "DB/API 기반 에이전트 유료 업로드 관리": "基于 DB/API 的代理付费上传管理",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "不保存 HTML，仅保存文本/图片块。",
    "fee_percent (선택, %)": "fee_percent（可选，%）",
    "fee_percent(유저)": "fee_percent（用户）",
    "onCredit 콜백이 연결되어 있지 않습니다.": "未连接 onCredit 回调。",
    "onDebit 콜백이 연결되어 있지 않습니다.": "未连接 onDebit 回调。",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· 服务器会重新验证类别/状态/费用/权限。",
    "· 소속유저": "· 所属用户",
    "개 · 남은 수량": "个 · 剩余数量",
    "검색 (id / user_code / nickname / 메모)": "搜索（id / user_code / nickname / 备注）",
    "게시일:": "发布日期：",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "支付项目金额必须是大于 0 的整数。",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "支付项目数量必须是大于等于 0 的整数。",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "支付项目数量不能小于已售数量。",
    "결제 항목명을 입력하세요.": "请输入支付项目名称。",
    "경로": "路径",
    "계정의 정보를 수정합니다.": "编辑账户信息。",
    "금액은 최소 50$ 이상 부터 가능합니다.": "金额最低必须为 50$。",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "这是我的账户及直接/间接下级（代理/用户）的资产移动记录。可使用筛选条件搜索。",
    "내 어카운트": "我的账户",
    "내 자산 0,000,000": "我的资产 0,000,000",
    "닉네임": "昵称",
    "등록된 결제 옵션이 없습니다.": "没有已注册的支付选项。",
    "등록된 라운지 글이 없습니다.": "没有已注册的 Lounge 文章。",
    "라운지 게시에 실패했습니다.\n{message}": "Lounge 发布失败。\n{message}",
    "라운지 목록 불러오는 중...": "正在加载 Lounge 列表...",
    "라운지 목록을 불러오지 못했습니다.": "无法加载 Lounge 列表。",
    "라운지 삭제에 실패했습니다.\n{message}": "Lounge 删除失败。\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "在 Lounge 详情中显示为按项目输入数量 + 支付按钮。",
    "라운지 저장에 실패했습니다.\n{message}": "Lounge 保存失败。\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "Lounge 暂停失败。\n{message}",
    "레이크백": "返水",
    "를 색상별로 누적 표시)": " 按颜色累计显示）",
    "만료일:": "到期日：",
    "메모": "备注",
    "받는쪽 (to)": "接收方 (to)",
    "발생시각": "发生时间",
    "보낸쪽 (from)": "发送方 (from)",
    "복사 실패(브라우저 권한 확인)": "复制失败（请检查浏览器权限）",
    "본문 내용을 입력하세요": "请输入正文内容",
    "본문 블록": "正文块",
    "본인 {id}": "本人 {id}",
    "비밀번호(미입력 시 변경 안 함)": "密码（不输入则不更改）",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "为防止事故，建议再次开始并确认后再进行。",
    "생성 (미체크 시 일반 유저 생성)": "创建（未勾选时创建普通用户）",
    "생성 실패: ": "创建失败：",
    "선택 입력": "可选输入",
    "세컨드 비밀번호(옵션)": "第二密码（可选）",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "如果与尝试转账的钱包地址不同，可能会丢失资金。申请前请务必再次确认。",
    "송금 완료 후 해당 버튼을 눌러주세요.": "转账完成后请点击该按钮。",
    "수정 모드": "编辑模式",
    "신규 작성": "新建",
    "썸네일 이미지": "缩略图",
    "업로드 URL을 받지 못했습니다.": "未收到上传 URL。",
    "업로드 비용": "上传费用",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "上传费用 {fee} USDT 将从 UserDB.asset 扣除，并自付款日起展示 {days} 天。是否发布？",
    "업로드/게시": "上传/发布",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "需要连接代理封锁/解除封锁 API。\n（目前仅支持用户封锁）",
    "예: 25": "例：25",
    "예: AGT3001 또는 user123": "例：AGT3001 或 user123",
    "오래된순": "最旧优先",
    "유저코드": "用户代码",
    "이 노드의 기본 수수료 비율(%)": "此节点的默认手续费比例 (%)",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "要删除这篇 Lounge 文章吗？\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "要暂停这篇 Lounge 文章吗？\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "一次性设置该代理下所有玩家的手续费",
    "이미지 alt 텍스트": "图片 alt 文本",
    "이미지 블록": "图片块",
    "이미지 업로드 중...": "图片上传中...",
    "이미지 업로드에 실패했습니다.": "图片上传失败。",
    "일": "天",
    "일 /": "天 /",
    "일/": "天/",
    "입력값을 확인해 주세요.": "请检查输入值。",
    "자산 으로 변환": "转换为资产",
    "자산 타입": "资产类型",
    "작성": "创建",
    "작성일:": "创建日期：",
    "재게시": "重新发布",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "保存免费，仅首次发布时从代理资产中扣除费用。",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "保存免费。仅首次上传/发布时从代理资产中扣除费用。",
    "적용": "应用",
    "전체": "全部",
    "전체 상태": "全部状态",
    "접기": "折叠",
    "정렬": "排序",
    "정보 수정 실패": "信息修改失败",
    "정보수정": "编辑信息",
    "정상": "正常",
    "제거": "移除",
    "제목을 입력하세요": "请输入标题",
    "종료일": "结束日",
    "중지": "暂停",
    "중지됨": "已暂停",
    "지갑 주소": "钱包地址",
    "지급": "发放",
    "지급 (대상: {targetId})": "发放（对象：{targetId}）",
    "차감": "扣除",
    "차감 (대상: {targetId})": "扣除（对象：{targetId}）",
    "차단": "封锁",
    "차단 해제": "解除封锁",
    "차단됨": "已封锁",
    "처리 중...": "处理中...",
    "초기화": "重置",
    "초안": "草稿",
    "총": "总计",
    "최근순": "最新优先",
    "출금하기": "提现",
    "충전 하기": "充值",
    "카테고리": "类别",
    "클릭 시 출금이 시작 됩니다.": "点击后将开始提现。",
    "클릭하여 이미지 업로드": "点击上传图片",
    "타입": "类型",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "测试交易会在转入 0.01 USDT 并确认入金正确后开始。",
    "텍스트 블록": "文本块",
    "판매": "销售",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "前端测试：转账完成处理（连接后端前）",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "前端测试：提现开始处理（连接后端前）",
    "플레이어 수수료 설정": "玩家手续费设置",
    "하위": "下级",
    "하위 생성 (부모:": "创建下级（父级：",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "对于此问题涉及的金额无法负责，请务必再次确认。",
    "확인용 테스트 거래 시작": "开始验证用测试交易",
    "회원 정보 수정": "编辑会员信息",
  },
  "vi": {
    " · 만료됨": " · Đã hết hạn",
    "% · 하위에이전트": "% · đại lý cấp dưới",
    "(본인/직속 하위 에이전트의": "(của bạn/đại lý cấp dưới trực tiếp",
    "(제목 없음)": "(không có tiêu đề)",
    "+ 이미지": "+ Hình ảnh",
    "+ 텍스트": "+ Văn bản",
    "0 이상 숫자를 입력하세요.": "Nhập số lớn hơn hoặc bằng 0.",
    "0보다 큰 금액을 입력하세요.": "Nhập số tiền lớn hơn 0.",
    "2차 비밀번호(선택)": "Mật khẩu cấp 2 (tùy chọn)",
    "DB/API 기반 에이전트 유료 업로드 관리": "Quản lý upload trả phí của đại lý dựa trên DB/API",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "Chỉ lưu khối văn bản/hình ảnh, không lưu HTML.",
    "fee_percent (선택, %)": "fee_percent (tùy chọn, %)",
    "fee_percent(유저)": "fee_percent (người dùng)",
    "onCredit 콜백이 연결되어 있지 않습니다.": "Callback onCredit chưa được kết nối.",
    "onDebit 콜백이 연결되어 있지 않습니다.": "Callback onDebit chưa được kết nối.",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· Máy chủ sẽ xác minh lại danh mục/trạng thái/chi phí/quyền.",
    "· 소속유저": "· người dùng thuộc nhóm",
    "개 · 남은 수량": "mục · Còn lại",
    "검색 (id / user_code / nickname / 메모)": "Tìm kiếm (id / user_code / nickname / ghi chú)",
    "게시일:": "Ngày đăng:",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "Số tiền mục thanh toán phải là số nguyên lớn hơn 0.",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "Số lượng mục thanh toán phải là số nguyên từ 0 trở lên.",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "Không thể đặt số lượng nhỏ hơn số đã bán.",
    "결제 항목명을 입력하세요.": "Nhập tên mục thanh toán.",
    "경로": "Đường dẫn",
    "계정의 정보를 수정합니다.": "Chỉnh sửa thông tin tài khoản.",
    "금액은 최소 50$ 이상 부터 가능합니다.": "Số tiền tối thiểu là 50$.",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "Lịch sử chuyển tài sản của tài khoản của tôi và cấp dưới trực tiếp/gián tiếp (đại lý/người dùng). Có thể tìm kiếm bằng bộ lọc.",
    "내 어카운트": "Tài khoản của tôi",
    "내 자산 0,000,000": "Tài sản của tôi 0,000,000",
    "닉네임": "Biệt danh",
    "등록된 결제 옵션이 없습니다.": "Không có tùy chọn thanh toán đã đăng ký.",
    "등록된 라운지 글이 없습니다.": "Không có bài lounge đã đăng ký.",
    "라운지 게시에 실패했습니다.\n{message}": "Đăng lounge thất bại.\n{message}",
    "라운지 목록 불러오는 중...": "Đang tải danh sách lounge...",
    "라운지 목록을 불러오지 못했습니다.": "Không thể tải danh sách lounge.",
    "라운지 삭제에 실패했습니다.\n{message}": "Xóa lounge thất bại.\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "Trong chi tiết lounge sẽ hiển thị nhập số lượng theo từng mục + nút thanh toán.",
    "라운지 저장에 실패했습니다.\n{message}": "Lưu lounge thất bại.\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "Tạm dừng lounge thất bại.\n{message}",
    "레이크백": "Rakeback",
    "를 색상별로 누적 표시)": " hiển thị cộng dồn theo màu)",
    "만료일:": "Ngày hết hạn:",
    "메모": "Ghi chú",
    "받는쪽 (to)": "Bên nhận (to)",
    "발생시각": "Thời điểm phát sinh",
    "보낸쪽 (from)": "Bên gửi (from)",
    "복사 실패(브라우저 권한 확인)": "Sao chép thất bại (kiểm tra quyền trình duyệt)",
    "본문 내용을 입력하세요": "Nhập nội dung chính",
    "본문 블록": "Khối nội dung",
    "본인 {id}": "Bạn {id}",
    "비밀번호(미입력 시 변경 안 함)": "Mật khẩu (để trống nếu không đổi)",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "Để tránh sự cố, nên bắt đầu lại và kiểm tra thêm một lần.",
    "생성 (미체크 시 일반 유저 생성)": "Tạo (không chọn sẽ tạo người dùng thường)",
    "생성 실패: ": "Tạo thất bại: ",
    "선택 입력": "Nhập tùy chọn",
    "세컨드 비밀번호(옵션)": "Mật khẩu thứ hai (tùy chọn)",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "Nếu khác địa chỉ ví dùng để chuyển tiền, bạn có thể mất tiền. Vui lòng kiểm tra lại trước khi yêu cầu.",
    "송금 완료 후 해당 버튼을 눌러주세요.": "Sau khi chuyển xong, hãy nhấn nút này.",
    "수정 모드": "Chế độ chỉnh sửa",
    "신규 작성": "Tạo mới",
    "썸네일 이미지": "Ảnh thumbnail",
    "업로드 URL을 받지 못했습니다.": "Không nhận được URL upload.",
    "업로드 비용": "Phí upload",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "Phí upload {fee} USDT sẽ bị trừ từ UserDB.asset và bài sẽ hiển thị trong {days} ngày kể từ ngày thanh toán. Đăng không?",
    "업로드/게시": "Upload/Đăng",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "Cần kết nối API chặn/bỏ chặn đại lý.\n(Hiện chỉ hỗ trợ chặn người dùng)",
    "예: 25": "VD: 25",
    "예: AGT3001 또는 user123": "VD: AGT3001 hoặc user123",
    "오래된순": "Cũ nhất trước",
    "유저코드": "Mã người dùng",
    "이 노드의 기본 수수료 비율(%)": "Tỷ lệ phí mặc định của node này (%)",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "Xóa bài lounge này?\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "Tạm dừng bài lounge này?\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "Thiết lập phí cho tất cả người chơi dưới đại lý này cùng lúc",
    "이미지 alt 텍스트": "Văn bản alt của ảnh",
    "이미지 블록": "Khối hình ảnh",
    "이미지 업로드 중...": "Đang upload ảnh...",
    "이미지 업로드에 실패했습니다.": "Upload ảnh thất bại.",
    "일": "ngày",
    "일 /": "ngày /",
    "일/": "ngày/",
    "입력값을 확인해 주세요.": "Vui lòng kiểm tra giá trị nhập.",
    "자산 으로 변환": "Chuyển thành tài sản",
    "자산 타입": "Loại tài sản",
    "작성": "Tạo",
    "작성일:": "Ngày tạo:",
    "재게시": "Đăng lại",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Lưu miễn phí, chỉ trừ phí từ tài sản đại lý khi đăng lần đầu.",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Lưu miễn phí. Chỉ trừ phí từ tài sản đại lý khi upload/đăng lần đầu.",
    "적용": "Áp dụng",
    "전체": "Tất cả",
    "전체 상태": "Tất cả trạng thái",
    "접기": "Thu gọn",
    "정렬": "Sắp xếp",
    "정보 수정 실패": "Chỉnh sửa thông tin thất bại",
    "정보수정": "Chỉnh sửa thông tin",
    "정상": "Bình thường",
    "제거": "Xóa bỏ",
    "제목을 입력하세요": "Nhập tiêu đề",
    "종료일": "Ngày kết thúc",
    "중지": "Dừng",
    "중지됨": "Đã dừng",
    "지갑 주소": "Địa chỉ ví",
    "지급": "Cộng",
    "지급 (대상: {targetId})": "Cộng (đối tượng: {targetId})",
    "차감": "Trừ",
    "차감 (대상: {targetId})": "Trừ (đối tượng: {targetId})",
    "차단": "Chặn",
    "차단 해제": "Bỏ chặn",
    "차단됨": "Đã chặn",
    "처리 중...": "Đang xử lý...",
    "초기화": "Đặt lại",
    "초안": "Bản nháp",
    "총": "Tổng",
    "최근순": "Mới nhất trước",
    "출금하기": "Rút tiền",
    "충전 하기": "Nạp tiền",
    "카테고리": "Danh mục",
    "클릭 시 출금이 시작 됩니다.": "Nhấn để bắt đầu rút tiền.",
    "클릭하여 이미지 업로드": "Nhấn để upload ảnh",
    "타입": "Loại",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "Giao dịch thử bắt đầu sau khi gửi 0.01 USDT và xác nhận khoản nạp chính xác.",
    "텍스트 블록": "Khối văn bản",
    "판매": "Bán",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Test frontend: xử lý hoàn tất chuyển tiền (trước khi kết nối backend)",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Test frontend: xử lý bắt đầu rút tiền (trước khi kết nối backend)",
    "플레이어 수수료 설정": "Thiết lập phí người chơi",
    "하위": "Cấp dưới",
    "하위 생성 (부모:": "Tạo cấp dưới (cha:",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "Chúng tôi không chịu trách nhiệm về số tiền liên quan đến vấn đề này, vui lòng kiểm tra lại.",
    "확인용 테스트 거래 시작": "Bắt đầu giao dịch thử để xác minh",
    "회원 정보 수정": "Chỉnh sửa thông tin thành viên",
  },
  "th": {
    " · 만료됨": " · หมดอายุ",
    "% · 하위에이전트": "% · เอเจนต์ย่อย",
    "(본인/직속 하위 에이전트의": "(ของคุณ/เอเจนต์ย่อยโดยตรง",
    "(제목 없음)": "(ไม่มีชื่อ)",
    "+ 이미지": "+ รูปภาพ",
    "+ 텍스트": "+ ข้อความ",
    "0 이상 숫자를 입력하세요.": "กรอกตัวเลขตั้งแต่ 0 ขึ้นไป",
    "0보다 큰 금액을 입력하세요.": "กรอกจำนวนเงินมากกว่า 0",
    "2차 비밀번호(선택)": "รหัสผ่านชั้นที่ 2 (ไม่บังคับ)",
    "DB/API 기반 에이전트 유료 업로드 관리": "จัดการอัปโหลดแบบชำระเงินของเอเจนต์ผ่าน DB/API",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "บันทึกเฉพาะบล็อกข้อความ/รูปภาพ โดยไม่บันทึก HTML",
    "fee_percent (선택, %)": "fee_percent (ไม่บังคับ, %)",
    "fee_percent(유저)": "fee_percent (ผู้ใช้)",
    "onCredit 콜백이 연결되어 있지 않습니다.": "ยังไม่ได้เชื่อมต่อ callback onCredit",
    "onDebit 콜백이 연결되어 있지 않습니다.": "ยังไม่ได้เชื่อมต่อ callback onDebit",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· เซิร์ฟเวอร์จะตรวจสอบหมวดหมู่/สถานะ/ค่าใช้จ่าย/สิทธิ์อีกครั้ง",
    "· 소속유저": "· ผู้ใช้ในสังกัด",
    "개 · 남은 수량": "รายการ · คงเหลือ",
    "검색 (id / user_code / nickname / 메모)": "ค้นหา (id / user_code / nickname / บันทึก)",
    "게시일:": "วันที่เผยแพร่:",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "จำนวนเงินของรายการชำระเงินต้องเป็นจำนวนเต็มมากกว่า 0",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "จำนวนรายการชำระเงินต้องเป็นจำนวนเต็มตั้งแต่ 0 ขึ้นไป",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "ไม่สามารถตั้งจำนวนน้อยกว่าจำนวนที่ขายไปแล้ว",
    "결제 항목명을 입력하세요.": "กรอกชื่อรายการชำระเงิน",
    "경로": "เส้นทาง",
    "계정의 정보를 수정합니다.": "แก้ไขข้อมูลบัญชี",
    "금액은 최소 50$ 이상 부터 가능합니다.": "จำนวนเงินขั้นต่ำคือ 50$",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "ประวัติการย้ายสินทรัพย์ของบัญชีของฉันและผู้ใต้บังคับบัญชาโดยตรง/โดยอ้อม (เอเจนต์/ผู้ใช้) สามารถค้นหาด้วยตัวกรองได้",
    "내 어카운트": "บัญชีของฉัน",
    "내 자산 0,000,000": "สินทรัพย์ของฉัน 0,000,000",
    "닉네임": "ชื่อเล่น",
    "등록된 결제 옵션이 없습니다.": "ไม่มีตัวเลือกการชำระเงินที่ลงทะเบียน",
    "등록된 라운지 글이 없습니다.": "ไม่มีโพสต์เลานจ์ที่ลงทะเบียน",
    "라운지 게시에 실패했습니다.\n{message}": "เผยแพร่เลานจ์ไม่สำเร็จ\n{message}",
    "라운지 목록 불러오는 중...": "กำลังโหลดรายการเลานจ์...",
    "라운지 목록을 불러오지 못했습니다.": "โหลดรายการเลานจ์ไม่สำเร็จ",
    "라운지 삭제에 실패했습니다.\n{message}": "ลบเลานจ์ไม่สำเร็จ\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "ในรายละเอียดเลานจ์จะแสดงช่องกรอกจำนวนรายรายการ + ปุ่มชำระเงิน",
    "라운지 저장에 실패했습니다.\n{message}": "บันทึกเลานจ์ไม่สำเร็จ\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "หยุดเลานจ์ไม่สำเร็จ\n{message}",
    "레이크백": "เรคแบ็ก",
    "를 색상별로 누적 표시)": " แสดงสะสมตามสี)",
    "만료일:": "วันหมดอายุ:",
    "메모": "บันทึก",
    "받는쪽 (to)": "ผู้รับ (to)",
    "발생시각": "เวลาที่เกิด",
    "보낸쪽 (from)": "ผู้ส่ง (from)",
    "복사 실패(브라우저 권한 확인)": "คัดลอกไม่สำเร็จ (ตรวจสอบสิทธิ์เบราว์เซอร์)",
    "본문 내용을 입력하세요": "กรอกเนื้อหา",
    "본문 블록": "บล็อกเนื้อหา",
    "본인 {id}": "ตัวเอง {id}",
    "비밀번호(미입력 시 변경 안 함)": "รหัสผ่าน (เว้นว่างถ้าไม่เปลี่ยน)",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "เพื่อป้องกันปัญหา แนะนำให้เริ่มใหม่และตรวจสอบอีกครั้ง",
    "생성 (미체크 시 일반 유저 생성)": "สร้าง (หากไม่เลือก จะสร้างผู้ใช้ทั่วไป)",
    "생성 실패: ": "สร้างไม่สำเร็จ: ",
    "선택 입력": "กรอกแบบไม่บังคับ",
    "세컨드 비밀번호(옵션)": "รหัสผ่านที่สอง (ตัวเลือก)",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "หากที่อยู่กระเป๋าไม่ตรงกับที่ใช้โอน คุณอาจสูญเสียเงิน โปรดตรวจสอบอีกครั้งก่อนส่งคำขอ",
    "송금 완료 후 해당 버튼을 눌러주세요.": "หลังโอนเสร็จ โปรดกดปุ่มนี้",
    "수정 모드": "โหมดแก้ไข",
    "신규 작성": "สร้างใหม่",
    "썸네일 이미지": "รูปภาพขนาดย่อ",
    "업로드 URL을 받지 못했습니다.": "ไม่ได้รับ URL สำหรับอัปโหลด",
    "업로드 비용": "ค่าอัปโหลด",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "ค่าอัปโหลด {fee} USDT จะถูกหักจาก UserDB.asset และจะแสดงเป็นเวลา {days} วันนับจากวันที่ชำระเงิน ต้องการเผยแพร่หรือไม่?",
    "업로드/게시": "อัปโหลด/เผยแพร่",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "ต้องเชื่อมต่อ API บล็อก/ปลดบล็อกเอเจนต์\n(ปัจจุบันรองรับเฉพาะการบล็อกผู้ใช้)",
    "예: 25": "เช่น: 25",
    "예: AGT3001 또는 user123": "เช่น: AGT3001 หรือ user123",
    "오래된순": "เก่าก่อน",
    "유저코드": "รหัสผู้ใช้",
    "이 노드의 기본 수수료 비율(%)": "อัตราค่าธรรมเนียมพื้นฐานของโหนดนี้ (%)",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "ต้องการลบโพสต์เลานจ์นี้หรือไม่?\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "ต้องการหยุดโพสต์เลานจ์นี้หรือไม่?\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "ตั้งค่าค่าธรรมเนียมผู้เล่นทั้งหมดใต้เอเจนต์นี้พร้อมกัน",
    "이미지 alt 텍스트": "ข้อความ alt ของรูปภาพ",
    "이미지 블록": "บล็อกรูปภาพ",
    "이미지 업로드 중...": "กำลังอัปโหลดรูปภาพ...",
    "이미지 업로드에 실패했습니다.": "อัปโหลดรูปภาพไม่สำเร็จ",
    "일": "วัน",
    "일 /": "วัน /",
    "일/": "วัน/",
    "입력값을 확인해 주세요.": "โปรดตรวจสอบค่าที่กรอก",
    "자산 으로 변환": "แปลงเป็นสินทรัพย์",
    "자산 타입": "ประเภทสินทรัพย์",
    "작성": "สร้าง",
    "작성일:": "วันที่สร้าง:",
    "재게시": "เผยแพร่อีกครั้ง",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "บันทึกฟรี หักค่าใช้จ่ายจากสินทรัพย์เอเจนต์เฉพาะการเผยแพร่ครั้งแรก",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "บันทึกฟรี หักค่าใช้จ่ายจากสินทรัพย์เอเจนต์เฉพาะการอัปโหลด/เผยแพร่ครั้งแรก",
    "적용": "ใช้",
    "전체": "ทั้งหมด",
    "전체 상태": "ทุกสถานะ",
    "접기": "ยุบ",
    "정렬": "เรียงลำดับ",
    "정보 수정 실패": "แก้ไขข้อมูลไม่สำเร็จ",
    "정보수정": "แก้ไขข้อมูล",
    "정상": "ปกติ",
    "제거": "นำออก",
    "제목을 입력하세요": "กรอกชื่อเรื่อง",
    "종료일": "วันที่สิ้นสุด",
    "중지": "หยุด",
    "중지됨": "หยุดแล้ว",
    "지갑 주소": "ที่อยู่กระเป๋า",
    "지급": "จ่าย",
    "지급 (대상: {targetId})": "จ่าย (เป้าหมาย: {targetId})",
    "차감": "หัก",
    "차감 (대상: {targetId})": "หัก (เป้าหมาย: {targetId})",
    "차단": "บล็อก",
    "차단 해제": "ปลดบล็อก",
    "차단됨": "ถูกบล็อก",
    "처리 중...": "กำลังประมวลผล...",
    "초기화": "รีเซ็ต",
    "초안": "ร่าง",
    "총": "รวม",
    "최근순": "ใหม่ก่อน",
    "출금하기": "ถอนเงิน",
    "충전 하기": "เติมเงิน",
    "카테고리": "หมวดหมู่",
    "클릭 시 출금이 시작 됩니다.": "คลิกเพื่อเริ่มถอนเงิน",
    "클릭하여 이미지 업로드": "คลิกเพื่ออัปโหลดรูปภาพ",
    "타입": "ประเภท",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "ธุรกรรมทดสอบจะเริ่มหลังจากส่ง 0.01 USDT และตรวจสอบว่าฝากเข้าถูกต้อง",
    "텍스트 블록": "บล็อกข้อความ",
    "판매": "ขาย",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "ทดสอบ Frontend: ประมวลผลโอนสำเร็จ (ก่อนเชื่อมต่อ backend)",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "ทดสอบ Frontend: ประมวลผลเริ่มถอน (ก่อนเชื่อมต่อ backend)",
    "플레이어 수수료 설정": "ตั้งค่าค่าธรรมเนียมผู้เล่น",
    "하위": "ย่อย",
    "하위 생성 (부모:": "สร้างย่อย (แม่:",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "ไม่สามารถรับผิดชอบจำนวนเงินจากปัญหานี้ได้ โปรดตรวจสอบอีกครั้ง",
    "확인용 테스트 거래 시작": "เริ่มธุรกรรมทดสอบเพื่อตรวจสอบ",
    "회원 정보 수정": "แก้ไขข้อมูลสมาชิก",
  },
  "ja": {
    " · 만료됨": " · 期限切れ",
    "% · 하위에이전트": "% · 下位エージェント",
    "(본인/직속 하위 에이전트의": "（本人/直属下位エージェントの",
    "(제목 없음)": "（タイトルなし）",
    "+ 이미지": "+ 画像",
    "+ 텍스트": "+ テキスト",
    "0 이상 숫자를 입력하세요.": "0以上の数値を入力してください。",
    "0보다 큰 금액을 입력하세요.": "0より大きい金額を入力してください。",
    "2차 비밀번호(선택)": "二次パスワード（任意）",
    "DB/API 기반 에이전트 유료 업로드 관리": "DB/APIベースのエージェント有料アップロード管理",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "HTMLは保存せず、テキスト/画像ブロックのみ保存します。",
    "fee_percent (선택, %)": "fee_percent（任意, %）",
    "fee_percent(유저)": "fee_percent（ユーザー）",
    "onCredit 콜백이 연결되어 있지 않습니다.": "onCreditコールバックが接続されていません。",
    "onDebit 콜백이 연결되어 있지 않습니다.": "onDebitコールバックが接続されていません。",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· サーバーでカテゴリ/状態/費用/権限を再検証します。",
    "· 소속유저": "· 所属ユーザー",
    "개 · 남은 수량": "個 · 残り数量",
    "검색 (id / user_code / nickname / 메모)": "検索（id / user_code / nickname / メモ）",
    "게시일:": "公開日:",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "決済項目の金額は0より大きい整数である必要があります。",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "決済項目の数量は0以上の整数である必要があります。",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "決済項目の数量は販売済み数量より小さくできません。",
    "결제 항목명을 입력하세요.": "決済項目名を入力してください。",
    "경로": "パス",
    "계정의 정보를 수정합니다.": "アカウント情報を編集します。",
    "금액은 최소 50$ 이상 부터 가능합니다.": "金額は最低50$以上から可能です。",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "自分のアカウントと直・間接下位（エージェント/ユーザー）の資産移動履歴です。フィルターを適用して検索できます。",
    "내 어카운트": "マイアカウント",
    "내 자산 0,000,000": "自分の資産 0,000,000",
    "닉네임": "ニックネーム",
    "등록된 결제 옵션이 없습니다.": "登録された決済オプションがありません。",
    "등록된 라운지 글이 없습니다.": "登録されたラウンジ投稿がありません。",
    "라운지 게시에 실패했습니다.\n{message}": "ラウンジ公開に失敗しました。\n{message}",
    "라운지 목록 불러오는 중...": "ラウンジ一覧を読み込み中...",
    "라운지 목록을 불러오지 못했습니다.": "ラウンジ一覧を読み込めませんでした。",
    "라운지 삭제에 실패했습니다.\n{message}": "ラウンジ削除に失敗しました。\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "ラウンジ詳細で項目別数量入力 + 決済ボタンとして表示されます。",
    "라운지 저장에 실패했습니다.\n{message}": "ラウンジ保存に失敗しました。\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "ラウンジ停止に失敗しました。\n{message}",
    "레이크백": "レーキバック",
    "를 색상별로 누적 표시)": "を色別に累積表示）",
    "만료일:": "有効期限:",
    "메모": "メモ",
    "받는쪽 (to)": "受取側 (to)",
    "발생시각": "発生時刻",
    "보낸쪽 (from)": "送信側 (from)",
    "복사 실패(브라우저 권한 확인)": "コピー失敗（ブラウザ権限を確認）",
    "본문 내용을 입력하세요": "本文を入力してください",
    "본문 블록": "本文ブロック",
    "본인 {id}": "本人 {id}",
    "비밀번호(미입력 시 변경 안 함)": "パスワード（未入力なら変更しない）",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "事故防止のため、もう一度開始後に行うことを推奨します。",
    "생성 (미체크 시 일반 유저 생성)": "作成（未チェック時は一般ユーザー作成）",
    "생성 실패: ": "作成失敗: ",
    "선택 입력": "任意入力",
    "세컨드 비밀번호(옵션)": "セカンドパスワード（任意）",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "送金しようとしているウォレットアドレスと異なる場合、資金を失う可能性があります。必ず再確認して申請してください。",
    "송금 완료 후 해당 버튼을 눌러주세요.": "送金完了後、このボタンを押してください。",
    "수정 모드": "編集モード",
    "신규 작성": "新規作成",
    "썸네일 이미지": "サムネイル画像",
    "업로드 URL을 받지 못했습니다.": "アップロードURLを受け取れませんでした。",
    "업로드 비용": "アップロード費用",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "アップロード費用 {fee} USDT が UserDB.asset から差し引かれ、決済日基準で {days} 日間掲載されます。公開しますか？",
    "업로드/게시": "アップロード/公開",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "エージェントのブロック/解除API接続が必要です。\n（現在はユーザーブロックのみ対応）",
    "예: 25": "例: 25",
    "예: AGT3001 또는 user123": "例: AGT3001 または user123",
    "오래된순": "古い順",
    "유저코드": "ユーザーコード",
    "이 노드의 기본 수수료 비율(%)": "このノードの基本手数料率（%）",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "このラウンジ投稿を削除処理しますか？\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "このラウンジ投稿を停止しますか？\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "このエージェント配下の全プレイヤー手数料を一括設定",
    "이미지 alt 텍스트": "画像altテキスト",
    "이미지 블록": "画像ブロック",
    "이미지 업로드 중...": "画像アップロード中...",
    "이미지 업로드에 실패했습니다.": "画像アップロードに失敗しました。",
    "일": "日",
    "일 /": "日 /",
    "일/": "日/",
    "입력값을 확인해 주세요.": "入力値を確認してください。",
    "자산 으로 변환": "資産に変換",
    "자산 타입": "資産タイプ",
    "작성": "作成",
    "작성일:": "作成日:",
    "재게시": "再公開",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "保存は無料で、初回公開時のみエージェント資産から費用が差し引かれます。",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "保存は無料です。初回アップロード/公開時のみエージェント資産から費用が差し引かれます。",
    "적용": "適用",
    "전체": "全体",
    "전체 상태": "全ステータス",
    "접기": "折りたたむ",
    "정렬": "並び替え",
    "정보 수정 실패": "情報修正失敗",
    "정보수정": "情報修正",
    "정상": "正常",
    "제거": "削除",
    "제목을 입력하세요": "タイトルを入力してください",
    "종료일": "終了日",
    "중지": "停止",
    "중지됨": "停止済み",
    "지갑 주소": "ウォレットアドレス",
    "지급": "支給",
    "지급 (대상: {targetId})": "支給（対象: {targetId}）",
    "차감": "差引",
    "차감 (대상: {targetId})": "差引（対象: {targetId}）",
    "차단": "ブロック",
    "차단 해제": "ブロック解除",
    "차단됨": "ブロック済み",
    "처리 중...": "処理中...",
    "초기화": "初期化",
    "초안": "下書き",
    "총": "合計",
    "최근순": "新しい順",
    "출금하기": "出金する",
    "충전 하기": "チャージする",
    "카테고리": "カテゴリ",
    "클릭 시 출금이 시작 됩니다.": "クリックすると出金が開始されます。",
    "클릭하여 이미지 업로드": "クリックして画像をアップロード",
    "타입": "タイプ",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "テスト取引は0.01USDTを送金し、正しく入金されたことを確認してから開始する取引です。",
    "텍스트 블록": "テキストブロック",
    "판매": "販売",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "フロントテスト: 送金完了処理（バックエンド接続前）",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "フロントテスト: 出金開始処理（バックエンド接続前）",
    "플레이어 수수료 설정": "プレイヤー手数料設定",
    "하위": "下位",
    "하위 생성 (부모:": "下位作成（親:",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "当該問題の金額については責任を負いかねますので、必ず再確認してください。",
    "확인용 테스트 거래 시작": "確認用テスト取引を開始",
    "회원 정보 수정": "会員情報修正",
  },
  "it": {
    " · 만료됨": " · Scaduto",
    "% · 하위에이전트": "% · sub-agenti",
    "(본인/직속 하위 에이전트의": "(di te/sub-agenti diretti",
    "(제목 없음)": "(senza titolo)",
    "+ 이미지": "+ Immagine",
    "+ 텍스트": "+ Testo",
    "0 이상 숫자를 입력하세요.": "Inserisci un numero maggiore o uguale a 0.",
    "0보다 큰 금액을 입력하세요.": "Inserisci un importo maggiore di 0.",
    "2차 비밀번호(선택)": "Password secondaria (opzionale)",
    "DB/API 기반 에이전트 유료 업로드 관리": "Gestione upload a pagamento degli agenti basata su DB/API",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "Salva solo blocchi testo/immagine senza salvare HTML.",
    "fee_percent (선택, %)": "fee_percent (opzionale, %)",
    "fee_percent(유저)": "fee_percent (utente)",
    "onCredit 콜백이 연결되어 있지 않습니다.": "Callback onCredit non collegato.",
    "onDebit 콜백이 연결되어 있지 않습니다.": "Callback onDebit non collegato.",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· Il server verifica di nuovo categoria/stato/costo/autorizzazioni.",
    "· 소속유저": "· utenti assegnati",
    "개 · 남은 수량": "pz · Quantità rimanente",
    "검색 (id / user_code / nickname / 메모)": "Cerca (id / user_code / nickname / memo)",
    "게시일:": "Pubblicato il:",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "L’importo della voce di pagamento deve essere un intero maggiore di 0.",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "La quantità della voce di pagamento deve essere un intero maggiore o uguale a 0.",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "La quantità non può essere inferiore alla quantità già venduta.",
    "결제 항목명을 입력하세요.": "Inserisci il nome della voce di pagamento.",
    "경로": "Percorso",
    "계정의 정보를 수정합니다.": "Modifica le informazioni dell’account.",
    "금액은 최소 50$ 이상 부터 가능합니다.": "L’importo minimo è 50$.",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "Registro dei movimenti asset del mio account e dei subordinati diretti/indiretti (agenti/utenti). Puoi cercare applicando filtri.",
    "내 어카운트": "Il mio account",
    "내 자산 0,000,000": "I miei asset 0,000,000",
    "닉네임": "Nickname",
    "등록된 결제 옵션이 없습니다.": "Non ci sono opzioni di pagamento registrate.",
    "등록된 라운지 글이 없습니다.": "Non ci sono post lounge registrati.",
    "라운지 게시에 실패했습니다.\n{message}": "Pubblicazione lounge non riuscita.\n{message}",
    "라운지 목록 불러오는 중...": "Caricamento lista lounge...",
    "라운지 목록을 불러오지 못했습니다.": "Impossibile caricare la lista lounge.",
    "라운지 삭제에 실패했습니다.\n{message}": "Eliminazione lounge non riuscita.\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "Nel dettaglio lounge viene mostrato come input quantità per voce + pulsante pagamento.",
    "라운지 저장에 실패했습니다.\n{message}": "Salvataggio lounge non riuscito.\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "Sospensione lounge non riuscita.\n{message}",
    "레이크백": "Rakeback",
    "를 색상별로 누적 표시)": " visualizzati cumulativamente per colore)",
    "만료일:": "Scade il:",
    "메모": "Memo",
    "받는쪽 (to)": "Destinatario (to)",
    "발생시각": "Ora evento",
    "보낸쪽 (from)": "Mittente (from)",
    "복사 실패(브라우저 권한 확인)": "Copia non riuscita (controlla i permessi del browser)",
    "본문 내용을 입력하세요": "Inserisci il contenuto",
    "본문 블록": "Blocco contenuto",
    "본인 {id}": "Tu {id}",
    "비밀번호(미입력 시 변경 안 함)": "Password (lascia vuoto per non modificare)",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "Per prevenire errori, si consiglia di ricominciare e verificare di nuovo.",
    "생성 (미체크 시 일반 유저 생성)": "Crea (se non selezionato crea un utente normale)",
    "생성 실패: ": "Creazione non riuscita: ",
    "선택 입력": "Input opzionale",
    "세컨드 비밀번호(옵션)": "Seconda password (opzionale)",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "Se l’indirizzo wallet è diverso da quello usato per il trasferimento, potresti perdere fondi. Controlla di nuovo prima della richiesta.",
    "송금 완료 후 해당 버튼을 눌러주세요.": "Premi questo pulsante dopo aver completato il trasferimento.",
    "수정 모드": "Modalità modifica",
    "신규 작성": "Nuova creazione",
    "썸네일 이미지": "Immagine miniatura",
    "업로드 URL을 받지 못했습니다.": "URL di upload non ricevuto.",
    "업로드 비용": "Costo upload",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "Il costo di upload {fee} USDT verrà detratto da UserDB.asset e pubblicato per {days} giorni dalla data di pagamento. Pubblicare?",
    "업로드/게시": "Upload/Pubblica",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "È necessario collegare l’API di blocco/sblocco agente.\n(Attualmente è supportato solo il blocco utenti)",
    "예: 25": "Es: 25",
    "예: AGT3001 또는 user123": "Es: AGT3001 o user123",
    "오래된순": "Più vecchi prima",
    "유저코드": "Codice utente",
    "이 노드의 기본 수수료 비율(%)": "Percentuale commissione base di questo nodo (%)",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "Eliminare questo post lounge?\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "Sospendere questo post lounge?\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "Imposta in una volta le commissioni di tutti i player sotto questo agente",
    "이미지 alt 텍스트": "Testo alt immagine",
    "이미지 블록": "Blocco immagine",
    "이미지 업로드 중...": "Upload immagine...",
    "이미지 업로드에 실패했습니다.": "Upload immagine non riuscito.",
    "일": "giorni",
    "일 /": "giorni /",
    "일/": "giorni/",
    "입력값을 확인해 주세요.": "Controlla i valori inseriti.",
    "자산 으로 변환": "Converti in asset",
    "자산 타입": "Tipo asset",
    "작성": "Crea",
    "작성일:": "Creato il:",
    "재게시": "Ripubblica",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Il salvataggio è gratuito; il costo viene detratto dagli asset dell’agente solo alla prima pubblicazione.",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "Il salvataggio è gratuito. Il costo viene detratto dagli asset dell’agente solo al primo upload/pubblicazione.",
    "적용": "Applica",
    "전체": "Tutti",
    "전체 상태": "Tutti gli stati",
    "접기": "Comprimi",
    "정렬": "Ordina",
    "정보 수정 실패": "Modifica informazioni non riuscita",
    "정보수정": "Modifica informazioni",
    "정상": "Normale",
    "제거": "Rimuovi",
    "제목을 입력하세요": "Inserisci il titolo",
    "종료일": "Data fine",
    "중지": "Sospendi",
    "중지됨": "Sospeso",
    "지갑 주소": "Indirizzo wallet",
    "지급": "Accredita",
    "지급 (대상: {targetId})": "Accredita (target: {targetId})",
    "차감": "Detrai",
    "차감 (대상: {targetId})": "Detrai (target: {targetId})",
    "차단": "Blocca",
    "차단 해제": "Sblocca",
    "차단됨": "Bloccato",
    "처리 중...": "Elaborazione...",
    "초기화": "Inizializza",
    "초안": "Bozza",
    "총": "Totale",
    "최근순": "Più recenti prima",
    "출금하기": "Preleva",
    "충전 하기": "Ricarica",
    "카테고리": "Categoria",
    "클릭 시 출금이 시작 됩니다.": "Cliccando inizierà il prelievo.",
    "클릭하여 이미지 업로드": "Clicca per caricare immagine",
    "타입": "Tipo",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "La transazione di test inizia dopo aver inviato 0.01 USDT e verificato il deposito corretto.",
    "텍스트 블록": "Blocco testo",
    "판매": "Vendita",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Test frontend: completamento trasferimento (prima del collegamento backend)",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Test frontend: avvio prelievo (prima del collegamento backend)",
    "플레이어 수수료 설정": "Impostazione commissione player",
    "하위": "Figlio",
    "하위 생성 (부모:": "Crea figlio (padre:",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "Non siamo responsabili dell’importo relativo a questo problema; controlla di nuovo.",
    "확인용 테스트 거래 시작": "Avvia transazione di test per verifica",
    "회원 정보 수정": "Modifica informazioni membro",
  },
  "fr": {
    " · 만료됨": " · Expiré",
    "% · 하위에이전트": "% · sous-agents",
    "(본인/직속 하위 에이전트의": "(de vous/sous-agents directs",
    "(제목 없음)": "(sans titre)",
    "+ 이미지": "+ Image",
    "+ 텍스트": "+ Texte",
    "0 이상 숫자를 입력하세요.": "Saisissez un nombre supérieur ou égal à 0.",
    "0보다 큰 금액을 입력하세요.": "Saisissez un montant supérieur à 0.",
    "2차 비밀번호(선택)": "Mot de passe secondaire (optionnel)",
    "DB/API 기반 에이전트 유료 업로드 관리": "Gestion des téléversements payants des agents basée sur DB/API",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "Seuls les blocs texte/image sont enregistrés, sans HTML.",
    "fee_percent (선택, %)": "fee_percent (optionnel, %)",
    "fee_percent(유저)": "fee_percent (utilisateur)",
    "onCredit 콜백이 연결되어 있지 않습니다.": "Le callback onCredit n’est pas connecté.",
    "onDebit 콜백이 연결되어 있지 않습니다.": "Le callback onDebit n’est pas connecté.",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· Le serveur revérifie la catégorie/le statut/le coût/les droits.",
    "· 소속유저": "· utilisateurs assignés",
    "개 · 남은 수량": "éléments · Quantité restante",
    "검색 (id / user_code / nickname / 메모)": "Rechercher (id / user_code / nickname / mémo)",
    "게시일:": "Publié le :",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "Le montant de l’élément de paiement doit être un entier supérieur à 0.",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "La quantité de l’élément de paiement doit être un entier supérieur ou égal à 0.",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "La quantité ne peut pas être inférieure à la quantité déjà vendue.",
    "결제 항목명을 입력하세요.": "Saisissez le nom de l’élément de paiement.",
    "경로": "Chemin",
    "계정의 정보를 수정합니다.": "Modifier les informations du compte.",
    "금액은 최소 50$ 이상 부터 가능합니다.": "Le montant minimum est de 50$.",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "Historique des mouvements d’actifs de mon compte et de mes subordonnés directs/indirects (agents/utilisateurs). Vous pouvez rechercher avec des filtres.",
    "내 어카운트": "Mon compte",
    "내 자산 0,000,000": "Mes actifs 0,000,000",
    "닉네임": "Pseudo",
    "등록된 결제 옵션이 없습니다.": "Aucune option de paiement enregistrée.",
    "등록된 라운지 글이 없습니다.": "Aucune publication lounge enregistrée.",
    "라운지 게시에 실패했습니다.\n{message}": "Échec de publication du lounge.\n{message}",
    "라운지 목록 불러오는 중...": "Chargement de la liste lounge...",
    "라운지 목록을 불러오지 못했습니다.": "Impossible de charger la liste lounge.",
    "라운지 삭제에 실패했습니다.\n{message}": "Échec de suppression du lounge.\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "Dans le détail lounge, cela s’affiche comme saisie de quantité par élément + bouton de paiement.",
    "라운지 저장에 실패했습니다.\n{message}": "Échec d’enregistrement du lounge.\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "Échec de suspension du lounge.\n{message}",
    "레이크백": "Rakeback",
    "를 색상별로 누적 표시)": " affichés cumulativement par couleur)",
    "만료일:": "Expire le :",
    "메모": "Mémo",
    "받는쪽 (to)": "Destinataire (to)",
    "발생시각": "Heure de l’événement",
    "보낸쪽 (from)": "Expéditeur (from)",
    "복사 실패(브라우저 권한 확인)": "Échec de copie (vérifiez les autorisations du navigateur)",
    "본문 내용을 입력하세요": "Saisissez le contenu",
    "본문 블록": "Bloc de contenu",
    "본인 {id}": "Vous {id}",
    "비밀번호(미입력 시 변경 안 함)": "Mot de passe (vide = pas de changement)",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "Pour éviter les incidents, il est recommandé de redémarrer et de revérifier.",
    "생성 (미체크 시 일반 유저 생성)": "Créer (si non coché, crée un utilisateur normal)",
    "생성 실패: ": "Échec de création : ",
    "선택 입력": "Saisie optionnelle",
    "세컨드 비밀번호(옵션)": "Second mot de passe (optionnel)",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "Si l’adresse du portefeuille diffère de celle utilisée pour le transfert, vous pouvez perdre des fonds. Veuillez revérifier avant de demander.",
    "송금 완료 후 해당 버튼을 눌러주세요.": "Appuyez sur ce bouton après avoir terminé le transfert.",
    "수정 모드": "Mode modification",
    "신규 작성": "Nouvelle création",
    "썸네일 이미지": "Image miniature",
    "업로드 URL을 받지 못했습니다.": "URL de téléversement non reçue.",
    "업로드 비용": "Coût de téléversement",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "Le coût de téléversement {fee} USDT sera déduit de UserDB.asset et publié pendant {days} jours à partir de la date de paiement. Publier ?",
    "업로드/게시": "Téléverser/Publier",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "Connexion API de blocage/déblocage agent requise.\n(Actuellement seul le blocage utilisateur est pris en charge)",
    "예: 25": "Ex : 25",
    "예: AGT3001 또는 user123": "Ex : AGT3001 ou user123",
    "오래된순": "Plus ancien d’abord",
    "유저코드": "Code utilisateur",
    "이 노드의 기본 수수료 비율(%)": "Taux de commission de base de ce nœud (%)",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "Supprimer cette publication lounge ?\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "Suspendre cette publication lounge ?\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "Définir en une fois les commissions de tous les joueurs sous cet agent",
    "이미지 alt 텍스트": "Texte alt de l’image",
    "이미지 블록": "Bloc image",
    "이미지 업로드 중...": "Téléversement de l’image...",
    "이미지 업로드에 실패했습니다.": "Échec du téléversement de l’image.",
    "일": "jours",
    "일 /": "jours /",
    "일/": "jours/",
    "입력값을 확인해 주세요.": "Veuillez vérifier les valeurs saisies.",
    "자산 으로 변환": "Convertir en actifs",
    "자산 타입": "Type d’actif",
    "작성": "Créer",
    "작성일:": "Créé le :",
    "재게시": "Republier",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "L’enregistrement est gratuit ; le coût est déduit des actifs de l’agent uniquement lors de la première publication.",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "L’enregistrement est gratuit. Le coût est déduit des actifs de l’agent uniquement lors du premier téléversement/publication.",
    "적용": "Appliquer",
    "전체": "Tous",
    "전체 상태": "Tous les statuts",
    "접기": "Replier",
    "정렬": "Trier",
    "정보 수정 실패": "Échec de modification des informations",
    "정보수정": "Modifier les informations",
    "정상": "Normal",
    "제거": "Retirer",
    "제목을 입력하세요": "Saisissez le titre",
    "종료일": "Date de fin",
    "중지": "Suspendre",
    "중지됨": "Suspendu",
    "지갑 주소": "Adresse du portefeuille",
    "지급": "Créditer",
    "지급 (대상: {targetId})": "Créditer (cible : {targetId})",
    "차감": "Déduire",
    "차감 (대상: {targetId})": "Déduire (cible : {targetId})",
    "차단": "Bloquer",
    "차단 해제": "Débloquer",
    "차단됨": "Bloqué",
    "처리 중...": "Traitement...",
    "초기화": "Réinitialiser",
    "초안": "Brouillon",
    "총": "Total",
    "최근순": "Plus récent d’abord",
    "출금하기": "Retirer",
    "충전 하기": "Recharger",
    "카테고리": "Catégorie",
    "클릭 시 출금이 시작 됩니다.": "Le retrait démarre au clic.",
    "클릭하여 이미지 업로드": "Cliquez pour téléverser une image",
    "타입": "Type",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "La transaction de test commence après l’envoi de 0.01 USDT et la vérification du dépôt correct.",
    "텍스트 블록": "Bloc texte",
    "판매": "Vente",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Test frontend : traitement du transfert terminé (avant connexion backend)",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Test frontend : traitement du début de retrait (avant connexion backend)",
    "플레이어 수수료 설정": "Paramètres de commission joueur",
    "하위": "Inférieur",
    "하위 생성 (부모:": "Créer inférieur (parent :",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "Nous ne pouvons être responsables du montant lié à ce problème, veuillez revérifier.",
    "확인용 테스트 거래 시작": "Démarrer la transaction de test de vérification",
    "회원 정보 수정": "Modifier les informations du membre",
  },
  "hi": {
    " · 만료됨": " · समाप्त",
    "% · 하위에이전트": "% · अधीन एजेंट",
    "(본인/직속 하위 에이전트의": "(आप/प्रत्यक्ष अधीन एजेंटों के",
    "(제목 없음)": "(कोई शीर्षक नहीं)",
    "+ 이미지": "+ छवि",
    "+ 텍스트": "+ पाठ",
    "0 이상 숫자를 입력하세요.": "0 या उससे बड़ा नंबर दर्ज करें।",
    "0보다 큰 금액을 입력하세요.": "0 से बड़ी राशि दर्ज करें।",
    "2차 비밀번호(선택)": "दूसरा पासवर्ड (वैकल्पिक)",
    "DB/API 기반 에이전트 유료 업로드 관리": "DB/API आधारित एजेंट पेड अपलोड प्रबंधन",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "HTML सहेजे बिना केवल टेक्स्ट/इमेज ब्लॉक सहेजे जाते हैं।",
    "fee_percent (선택, %)": "fee_percent (वैकल्पिक, %)",
    "fee_percent(유저)": "fee_percent (यूज़र)",
    "onCredit 콜백이 연결되어 있지 않습니다.": "onCredit callback कनेक्ट नहीं है।",
    "onDebit 콜백이 연결되어 있지 않습니다.": "onDebit callback कनेक्ट नहीं है।",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· सर्वर कैटेगरी/स्थिति/लागत/अनुमति फिर से सत्यापित करता है।",
    "· 소속유저": "· संबद्ध यूज़र",
    "개 · 남은 수량": "आइटम · शेष मात्रा",
    "검색 (id / user_code / nickname / 메모)": "खोजें (id / user_code / nickname / मेमो)",
    "게시일:": "प्रकाशन तिथि:",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "भुगतान आइटम की राशि 0 से बड़ा पूर्णांक होनी चाहिए।",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "भुगतान आइटम की मात्रा 0 या उससे बड़ा पूर्णांक होनी चाहिए।",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "मात्रा पहले से बेची गई मात्रा से कम नहीं की जा सकती।",
    "결제 항목명을 입력하세요.": "भुगतान आइटम का नाम दर्ज करें।",
    "경로": "पथ",
    "계정의 정보를 수정합니다.": "खाते की जानकारी संपादित करें।",
    "금액은 최소 50$ 이상 부터 가능합니다.": "राशि कम से कम 50$ होनी चाहिए।",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "मेरे खाते और प्रत्यक्ष/अप्रत्यक्ष अधीन (एजेंट/यूज़र) की एसेट मूवमेंट हिस्ट्री है। फ़िल्टर लगाकर खोज सकते हैं।",
    "내 어카운트": "मेरा अकाउंट",
    "내 자산 0,000,000": "मेरे एसेट 0,000,000",
    "닉네임": "निकनेम",
    "등록된 결제 옵션이 없습니다.": "कोई पंजीकृत भुगतान विकल्प नहीं है।",
    "등록된 라운지 글이 없습니다.": "कोई पंजीकृत lounge पोस्ट नहीं है।",
    "라운지 게시에 실패했습니다.\n{message}": "Lounge प्रकाशित करने में विफल।\n{message}",
    "라운지 목록 불러오는 중...": "Lounge सूची लोड हो रही है...",
    "라운지 목록을 불러오지 못했습니다.": "Lounge सूची लोड नहीं हो सकी।",
    "라운지 삭제에 실패했습니다.\n{message}": "Lounge हटाने में विफल।\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "Lounge विवरण में प्रत्येक आइटम की मात्रा इनपुट + भुगतान बटन के रूप में दिखेगा।",
    "라운지 저장에 실패했습니다.\n{message}": "Lounge सहेजने में विफल।\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "Lounge रोकने में विफल।\n{message}",
    "레이크백": "Rakeback",
    "를 색상별로 누적 표시)": " रंग के अनुसार संचयी रूप से दिखाए जाते हैं)",
    "만료일:": "समाप्ति तिथि:",
    "메모": "मेमो",
    "받는쪽 (to)": "प्राप्तकर्ता (to)",
    "발생시각": "घटना समय",
    "보낸쪽 (from)": "भेजने वाला (from)",
    "복사 실패(브라우저 권한 확인)": "कॉपी विफल (ब्राउज़र अनुमति जांचें)",
    "본문 내용을 입력하세요": "मुख्य सामग्री दर्ज करें",
    "본문 블록": "सामग्री ब्लॉक",
    "본인 {id}": "आप {id}",
    "비밀번호(미입력 시 변경 안 함)": "पासवर्ड (खाली छोड़ें तो बदलाव नहीं)",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "गलती रोकने के लिए दोबारा शुरू करके फिर जाँच करने की सलाह है।",
    "생성 (미체크 시 일반 유저 생성)": "बनाएँ (अनचेक होने पर सामान्य यूज़र बनेगा)",
    "생성 실패: ": "बनाने में विफल: ",
    "선택 입력": "वैकल्पिक इनपुट",
    "세컨드 비밀번호(옵션)": "दूसरा पासवर्ड (विकल्प)",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "यदि वॉलेट पता ट्रांसफर वाले पते से अलग है, तो धन खो सकता है। अनुरोध से पहले कृपया दोबारा जाँचें।",
    "송금 완료 후 해당 버튼을 눌러주세요.": "ट्रांसफर पूरा होने के बाद यह बटन दबाएँ।",
    "수정 모드": "संपादन मोड",
    "신규 작성": "नया बनाएँ",
    "썸네일 이미지": "थंबनेल छवि",
    "업로드 URL을 받지 못했습니다.": "अपलोड URL प्राप्त नहीं हुआ।",
    "업로드 비용": "अपलोड शुल्क",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "अपलोड शुल्क {fee} USDT UserDB.asset से कटेगा और भुगतान तिथि से {days} दिनों तक प्रकाशित रहेगा। प्रकाशित करें?",
    "업로드/게시": "अपलोड/प्रकाशित",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "एजेंट ब्लॉक/अनब्लॉक API कनेक्शन आवश्यक है।\n(फिलहाल केवल यूज़र ब्लॉक समर्थित है)",
    "예: 25": "उदा: 25",
    "예: AGT3001 또는 user123": "उदा: AGT3001 या user123",
    "오래된순": "पुराने पहले",
    "유저코드": "यूज़र कोड",
    "이 노드의 기본 수수료 비율(%)": "इस नोड की मूल शुल्क दर (%)",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "इस lounge पोस्ट को हटाएँ?\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "इस lounge पोस्ट को रोकें?\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "इस एजेंट के नीचे सभी खिलाड़ियों की फीस एक साथ सेट करें",
    "이미지 alt 텍스트": "छवि alt टेक्स्ट",
    "이미지 블록": "छवि ब्लॉक",
    "이미지 업로드 중...": "छवि अपलोड हो रही है...",
    "이미지 업로드에 실패했습니다.": "छवि अपलोड विफल।",
    "일": "दिन",
    "일 /": "दिन /",
    "일/": "दिन/",
    "입력값을 확인해 주세요.": "कृपया इनपुट मान जाँचें।",
    "자산 으로 변환": "एसेट में बदलें",
    "자산 타입": "एसेट प्रकार",
    "작성": "बनाएँ",
    "작성일:": "बनाने की तिथि:",
    "재게시": "फिर प्रकाशित करें",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "सहेजना मुफ्त है; शुल्क केवल पहली प्रकाशन पर एजेंट एसेट से कटेगा।",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "सहेजना मुफ्त है। शुल्क केवल पहले अपलोड/प्रकाशन पर एजेंट एसेट से कटेगा।",
    "적용": "लागू करें",
    "전체": "सभी",
    "전체 상태": "सभी स्थितियाँ",
    "접기": "समेटें",
    "정렬": "क्रमबद्ध करें",
    "정보 수정 실패": "जानकारी संपादन विफल",
    "정보수정": "जानकारी संपादित करें",
    "정상": "सामान्य",
    "제거": "हटाएँ",
    "제목을 입력하세요": "शीर्षक दर्ज करें",
    "종료일": "समाप्ति तिथि",
    "중지": "रोकें",
    "중지됨": "रोका गया",
    "지갑 주소": "वॉलेट पता",
    "지급": "क्रेडिट",
    "지급 (대상: {targetId})": "क्रेडिट (लक्ष्य: {targetId})",
    "차감": "कटौती",
    "차감 (대상: {targetId})": "कटौती (लक्ष्य: {targetId})",
    "차단": "ब्लॉक",
    "차단 해제": "अनब्लॉक",
    "차단됨": "ब्लॉक किया गया",
    "처리 중...": "प्रोसेस हो रहा है...",
    "초기화": "रीसेट",
    "초안": "ड्राफ्ट",
    "총": "कुल",
    "최근순": "नए पहले",
    "출금하기": "निकासी करें",
    "충전 하기": "जमा करें",
    "카테고리": "कैटेगरी",
    "클릭 시 출금이 시작 됩니다.": "क्लिक करने पर निकासी शुरू होगी।",
    "클릭하여 이미지 업로드": "छवि अपलोड करने के लिए क्लिक करें",
    "타입": "प्रकार",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "टेस्ट ट्रांजैक्शन 0.01 USDT भेजकर सही जमा की पुष्टि के बाद शुरू होता है।",
    "텍스트 블록": "टेक्स्ट ब्लॉक",
    "판매": "बिक्री",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "फ्रंट टेस्ट: ट्रांसफर पूर्ण 처리 (backend कनेक्शन से पहले)",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "फ्रंट टेस्ट: निकासी शुरू 처리 (backend कनेक्शन से पहले)",
    "플레이어 수수료 설정": "प्लेयर फीस सेटिंग",
    "하위": "अधीन",
    "하위 생성 (부모:": "अधीन बनाएँ (पैरेंट:",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "इस समस्या से संबंधित राशि के लिए हम जिम्मेदार नहीं हैं, कृपया दोबारा जाँचें।",
    "확인용 테스트 거래 시작": "सत्यापन टेस्ट ट्रांजैक्शन शुरू करें",
    "회원 정보 수정": "सदस्य जानकारी संपादित करें",
  },
  "ur": {
    " · 만료됨": " · میعاد ختم",
    "% · 하위에이전트": "% · ذیلی ایجنٹس",
    "(본인/직속 하위 에이전트의": "(آپ/براہ راست ذیلی ایجنٹس کے",
    "(제목 없음)": "(بغیر عنوان)",
    "+ 이미지": "+ تصویر",
    "+ 텍스트": "+ متن",
    "0 이상 숫자를 입력하세요.": "0 یا اس سے بڑا نمبر درج کریں۔",
    "0보다 큰 금액을 입력하세요.": "0 سے زیادہ رقم درج کریں۔",
    "2차 비밀번호(선택)": "دوسرا پاس ورڈ (اختیاری)",
    "DB/API 기반 에이전트 유료 업로드 관리": "DB/API پر مبنی ایجنٹ پیڈ اپ لوڈ مینجمنٹ",
    "HTML 저장 없이 텍스트/이미지 블록만 저장합니다.": "HTML محفوظ کیے بغیر صرف متن/تصویر بلاکس محفوظ ہوں گے۔",
    "fee_percent (선택, %)": "fee_percent (اختیاری، %)",
    "fee_percent(유저)": "fee_percent (یوزر)",
    "onCredit 콜백이 연결되어 있지 않습니다.": "onCredit callback منسلک نہیں ہے۔",
    "onDebit 콜백이 연결되어 있지 않습니다.": "onDebit callback منسلک نہیں ہے۔",
    "· 서버에서 카테고리/상태/비용/권한을 다시 검증합니다.": "· سرور کیٹیگری/حالت/لاگت/اجازت دوبارہ چیک کرے گا۔",
    "· 소속유저": "· متعلقہ یوزرز",
    "개 · 남은 수량": "آئٹمز · باقی مقدار",
    "검색 (id / user_code / nickname / 메모)": "تلاش (id / user_code / nickname / میمو)",
    "게시일:": "اشاعت کی تاریخ:",
    "결제 항목 금액은 0보다 큰 정수여야 합니다.": "ادائیگی آئٹم کی رقم 0 سے بڑا صحیح عدد ہونا چاہیے۔",
    "결제 항목 수량은 0 이상 정수여야 합니다.": "ادائیگی آئٹم کی مقدار 0 یا اس سے بڑا صحیح عدد ہونا چاہیے۔",
    "결제 항목 수량은 이미 판매된 수량보다 작게 수정할 수 없습니다.": "مقدار پہلے سے فروخت شدہ مقدار سے کم نہیں کی جا سکتی۔",
    "결제 항목명을 입력하세요.": "ادائیگی آئٹم کا نام درج کریں۔",
    "경로": "راستہ",
    "계정의 정보를 수정합니다.": "اکاؤنٹ کی معلومات میں ترمیم کریں۔",
    "금액은 최소 50$ 이상 부터 가능합니다.": "رقم کم از کم 50$ ہونی چاہیے۔",
    "내 계정과 직·간접 하위(에이전트/유저)의 자산 이동 기록입니다. 필터를 적용해 검색할 수 있어요.": "میرے اکاؤنٹ اور براہ راست/بالواسطہ ذیلی (ایجنٹ/یوزر) کے اثاثہ منتقلی ریکارڈز۔ فلٹر لگا کر تلاش کر سکتے ہیں۔",
    "내 어카운트": "میرا اکاؤنٹ",
    "내 자산 0,000,000": "میرے اثاثے 0,000,000",
    "닉네임": "نک نیم",
    "등록된 결제 옵션이 없습니다.": "کوئی رجسٹرڈ ادائیگی آپشن نہیں ہے۔",
    "등록된 라운지 글이 없습니다.": "کوئی رجسٹرڈ lounge پوسٹ نہیں ہے۔",
    "라운지 게시에 실패했습니다.\n{message}": "Lounge شائع کرنے میں ناکامی۔\n{message}",
    "라운지 목록 불러오는 중...": "Lounge فہرست لوڈ ہو رہی ہے...",
    "라운지 목록을 불러오지 못했습니다.": "Lounge فہرست لوڈ نہیں ہو سکی۔",
    "라운지 삭제에 실패했습니다.\n{message}": "Lounge حذف کرنے میں ناکامی۔\n{message}",
    "라운지 상세에서 항목별 수량 입력 + 결제 버튼으로 표시됩니다.": "Lounge تفصیل میں ہر آئٹم کی مقدار ان پٹ + ادائیگی بٹن کے طور پر دکھے گا۔",
    "라운지 저장에 실패했습니다.\n{message}": "Lounge محفوظ کرنے میں ناکامی۔\n{message}",
    "라운지 중지에 실패했습니다.\n{message}": "Lounge روکنے میں ناکامی۔\n{message}",
    "레이크백": "Rakeback",
    "를 색상별로 누적 표시)": " رنگ کے لحاظ سے مجموعی طور پر دکھائے جاتے ہیں)",
    "만료일:": "میعاد ختم:",
    "메모": "میمو",
    "받는쪽 (to)": "وصول کنندہ (to)",
    "발생시각": "واقعہ کا وقت",
    "보낸쪽 (from)": "بھیجنے والا (from)",
    "복사 실패(브라우저 권한 확인)": "کاپی ناکام (براؤزر اجازت چیک کریں)",
    "본문 내용을 입력하세요": "اصل مواد درج کریں",
    "본문 블록": "مواد بلاک",
    "본인 {id}": "آپ {id}",
    "비밀번호(미입력 시 변경 안 함)": "پاس ورڈ (خالی چھوڑیں تو تبدیلی نہیں)",
    "사고 예방을 위해 다시한번 시작 후 하시는 것을 추천 합니다.": "غلطی سے بچنے کے لیے دوبارہ شروع کر کے پھر چیک کرنے کی سفارش ہے۔",
    "생성 (미체크 시 일반 유저 생성)": "بنائیں (غیر منتخب ہونے پر عام یوزر بنے گا)",
    "생성 실패: ": "بنانے میں ناکامی: ",
    "선택 입력": "اختیاری ان پٹ",
    "세컨드 비밀번호(옵션)": "دوسرا پاس ورڈ (اختیاری)",
    "송금 시도하는 지갑 주소 와 다를시 돈을 잃을 수 있습니다. 꼭 다시 한번 확인 후 신청 부탁 드립니다.": "اگر wallet address ٹرانسفر والے address سے مختلف ہو تو رقم ضائع ہو سکتی ہے۔ درخواست سے پہلے دوبارہ چیک کریں۔",
    "송금 완료 후 해당 버튼을 눌러주세요.": "ٹرانسفر مکمل ہونے کے بعد یہ بٹن دبائیں۔",
    "수정 모드": "ترمیم موڈ",
    "신규 작성": "نیا بنائیں",
    "썸네일 이미지": "تھمب نیل تصویر",
    "업로드 URL을 받지 못했습니다.": "اپ لوڈ URL موصول نہیں ہوا۔",
    "업로드 비용": "اپ لوڈ فیس",
    "업로드 비용 {fee} USDT가 UserDB.asset에서 차감되고, 결제일 기준 {days}일 동안 게시됩니다. 게시할까요?": "اپ لوڈ فیس {fee} USDT UserDB.asset سے کاٹی جائے گی اور ادائیگی کی تاریخ سے {days} دن شائع رہے گی۔ شائع کریں؟",
    "업로드/게시": "اپ لوڈ/شائع",
    "에이전트 차단/해제 API 연결이 필요합니다.\n(현재는 사용자 차단만 지원 중)": "ایجنٹ بلاک/ان بلاک API کنکشن درکار ہے۔\n(فی الحال صرف یوزر بلاک سپورٹ ہے)",
    "예: 25": "مثال: 25",
    "예: AGT3001 또는 user123": "مثال: AGT3001 یا user123",
    "오래된순": "پرانے پہلے",
    "유저코드": "یوزر کوڈ",
    "이 노드의 기본 수수료 비율(%)": "اس نوڈ کی بنیادی فیس شرح (%)",
    "이 라운지 글을 삭제 처리할까요?\n\n- {title}": "کیا یہ lounge پوسٹ حذف کریں؟\n\n- {title}",
    "이 라운지 글을 중지할까요?\n\n- {title}": "کیا یہ lounge پوسٹ روکیں؟\n\n- {title}",
    "이 에이전트 밑 모든 플레이어 수수료를 한 번에 설정": "اس ایجنٹ کے نیچے تمام players کی فیس ایک ساتھ سیٹ کریں",
    "이미지 alt 텍스트": "تصویر alt متن",
    "이미지 블록": "تصویر بلاک",
    "이미지 업로드 중...": "تصویر اپ لوڈ ہو رہی ہے...",
    "이미지 업로드에 실패했습니다.": "تصویر اپ لوڈ ناکام۔",
    "일": "دن",
    "일 /": "دن /",
    "일/": "دن/",
    "입력값을 확인해 주세요.": "براہ کرم ان پٹ values چیک کریں۔",
    "자산 으로 변환": "اثاثہ میں تبدیل کریں",
    "자산 타입": "اثاثہ قسم",
    "작성": "بنائیں",
    "작성일:": "بنانے کی تاریخ:",
    "재게시": "دوبارہ شائع",
    "저장은 무료, 최초 게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "محفوظ کرنا مفت ہے؛ فیس صرف پہلی اشاعت پر ایجنٹ اثاثوں سے کٹے گی۔",
    "저장은 무료입니다. 최초 업로드/게시 시에만 에이전트 자산에서 비용이 차감됩니다.": "محفوظ کرنا مفت ہے۔ فیس صرف پہلے اپ لوڈ/اشاعت پر ایجنٹ اثاثوں سے کٹے گی۔",
    "적용": "لاگو کریں",
    "전체": "سب",
    "전체 상태": "تمام حالتیں",
    "접기": "بند کریں",
    "정렬": "ترتیب",
    "정보 수정 실패": "معلومات ترمیم ناکام",
    "정보수정": "معلومات ترمیم",
    "정상": "نارمل",
    "제거": "ہٹائیں",
    "제목을 입력하세요": "عنوان درج کریں",
    "종료일": "اختتامی تاریخ",
    "중지": "روکیں",
    "중지됨": "روکا گیا",
    "지갑 주소": "Wallet address",
    "지급": "کریڈٹ",
    "지급 (대상: {targetId})": "کریڈٹ (ہدف: {targetId})",
    "차감": "کٹوتی",
    "차감 (대상: {targetId})": "کٹوتی (ہدف: {targetId})",
    "차단": "بلاک",
    "차단 해제": "ان بلاک",
    "차단됨": "بلاک شدہ",
    "처리 중...": "پروسیسنگ...",
    "초기화": "ری سیٹ",
    "초안": "ڈرافٹ",
    "총": "کل",
    "최근순": "نئے پہلے",
    "출금하기": "نکلوائیں",
    "충전 하기": "جمع کریں",
    "카테고리": "کیٹیگری",
    "클릭 시 출금이 시작 됩니다.": "کلک کرنے پر withdrawal شروع ہوگا۔",
    "클릭하여 이미지 업로드": "تصویر اپ لوڈ کرنے کے لیے کلک کریں",
    "타입": "قسم",
    "테스트 거래는 0.01USDT 를 송금 하여 올바른 입금이 되었는지 확인 후 시작 하는 거래 입니다.": "Test transaction 0.01 USDT بھیج کر درست deposit کی تصدیق کے بعد شروع ہوتا ہے۔",
    "텍스트 블록": "متن بلاک",
    "판매": "فروخت",
    "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Frontend test: transfer complete 처리 (backend connection سے پہلے)",
    "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Frontend test: withdrawal start 처리 (backend connection سے پہلے)",
    "플레이어 수수료 설정": "Player fee setting",
    "하위": "ذیلی",
    "하위 생성 (부모:": "ذیلی بنائیں (parent:",
    "해당 문제의 금액에 관해서는 책임이 불가하오니 반드시 다시 확인 해주 시길 바랍니다.": "اس مسئلے سے متعلق رقم کے لیے ہم ذمہ دار نہیں، براہ کرم دوبارہ چیک کریں۔",
    "확인용 테스트 거래 시작": "تصدیق کے لیے test transaction شروع کریں",
    "회원 정보 수정": "رکن معلومات ترمیم",
  },
};

const paymentSupplement = {
  "ko": {
    "요청 처리 중 오류가 발생했습니다.": "요청 처리 중 오류가 발생했습니다.",
    "완료": "완료",
    "진행중": "진행중",
    "검토필요": "검토필요",
    "취소": "취소",
    "실패": "실패",
    "환전": "환전",
    "충전": "충전",
    "USDT TRC20 메인넷": "USDT TRC20 메인넷",
    "정책 확인 중": "정책 확인 중",
    "x3 베팅요건 충족": "x3 베팅요건 충족",
    "x3 남은 베팅 {amount}": "x3 남은 베팅 {amount}",
    "입금주소 발급 실패": "입금주소 발급 실패",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.",
    "먼저 입금주소를 발급하세요.": "먼저 입금주소를 발급하세요.",
    "충전 요청 실패": "충전 요청 실패",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.",
    "환전 요청 실패": "환전 요청 실패",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.",
    "취소 실패": "취소 실패",
    "요청 취소 처리를 보냈습니다.": "요청 취소 처리를 보냈습니다.",
    "재확인 실패": "재확인 실패",
    "입금 재확인 요청을 보냈습니다.": "입금 재확인 요청을 보냈습니다.",
    "어드민 결제": "어드민 결제",
    "내 자산": "내 자산",
    "출금가능 검증금액": "출금가능 검증금액",
    "x3 베팅요건": "x3 베팅요건",
    "운영수익 정책": "운영수익 정책",
    "개인 출금가능금액에 미가산": "개인 출금가능금액에 미가산",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.",
    "결제 네트워크": "결제 네트워크",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.",
    "환전하기": "환전하기",
    "충전하기": "충전하기",
    "Admin Charge": "Admin Charge",
    "내 송금 지갑 주소": "내 송금 지갑 주소",
    "선택 입력: 내가 송금하는 지갑 주소": "선택 입력: 내가 송금하는 지갑 주소",
    "예상 금액": "예상 금액",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "선택 입력: 실제 반영은 온체인 입금액 기준",
    "발급 중...": "발급 중...",
    "입금주소 발급": "입금주소 발급",
    "입금 지갑 주소": "입금 지갑 주소",
    "입금주소 발급 후 표시됩니다.": "입금주소 발급 후 표시됩니다.",
    "복사": "복사",
    "복사 실패": "복사 실패",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.",
    "등록 중...": "등록 중...",
    "송금 완료 후 충전 확인 요청": "송금 완료 후 충전 확인 요청",
    "Admin Exchange": "Admin Exchange",
    "받는 지갑": "받는 지갑",
    "환전 받을 USDT TRC20 메인넷 주소": "환전 받을 USDT TRC20 메인넷 주소",
    "금액": "금액",
    "환전 금액": "환전 금액",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.",
    "환전 요청": "환전 요청",
    "최근 결제 요청": "최근 결제 요청",
    "새로고침": "새로고침",
    "구분": "구분",
    "상태": "상태",
    "주소": "주소",
    "요청ID": "요청ID",
    "관리": "관리",
    "불러오는 중...": "불러오는 중...",
    "결제 요청 내역이 없습니다.": "결제 요청 내역이 없습니다.",
    "재확인": "재확인"
  },
  "en": {
    "요청 처리 중 오류가 발생했습니다.": "An error occurred while processing the request.",
    "완료": "Completed",
    "진행중": "In progress",
    "검토필요": "Needs review",
    "취소": "Canceled",
    "실패": "Failed",
    "환전": "Withdrawal",
    "충전": "Deposit",
    "USDT TRC20 메인넷": "USDT TRC20 Mainnet",
    "정책 확인 중": "Checking policy",
    "x3 베팅요건 충족": "x3 wagering requirement met",
    "x3 남은 베팅 {amount}": "x3 remaining wager {amount}",
    "입금주소 발급 실패": "Failed to issue deposit address",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "A deposit address has been issued. Send funds to that address, then press the completion button.",
    "먼저 입금주소를 발급하세요.": "Issue a deposit address first.",
    "충전 요청 실패": "Deposit request failed",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "Deposit request registered. The actual credited amount will be based on the on-chain amount verified by the bridge.",
    "환전 요청 실패": "Withdrawal request failed",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "Withdrawal request registered. It proceeds only after passing the x3 requirement and DB withdrawable amount checks.",
    "취소 실패": "Cancellation failed",
    "요청 취소 처리를 보냈습니다.": "The cancellation request has been sent.",
    "재확인 실패": "Recheck failed",
    "입금 재확인 요청을 보냈습니다.": "Deposit recheck request has been sent.",
    "어드민 결제": "Admin Payment",
    "내 자산": "My Asset",
    "출금가능 검증금액": "Verified Withdrawable Amount",
    "x3 베팅요건": "x3 Wagering Requirement",
    "운영수익 정책": "Operating Revenue Policy",
    "개인 출금가능금액에 미가산": "Not added to personal withdrawable amount",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "Admin direct deposits record the same x3 wagering requirement as users. Operating revenue such as game fees, rake, and commissions is not added to the admin's personal withdrawable amount and is separated into a revenue ledger.",
    "결제 네트워크": "Payment Network",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "The current production environment uses only USDT TRC20 Mainnet.",
    "환전하기": "Withdraw",
    "충전하기": "Deposit",
    "Admin Charge": "Admin Deposit",
    "내 송금 지갑 주소": "My Sending Wallet Address",
    "선택 입력: 내가 송금하는 지갑 주소": "Optional: wallet address I send from",
    "예상 금액": "Estimated Amount",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "Optional: actual credit is based on the on-chain deposit amount",
    "발급 중...": "Issuing...",
    "입금주소 발급": "Issue Deposit Address",
    "입금 지갑 주소": "Deposit Wallet Address",
    "입금주소 발급 후 표시됩니다.": "Displayed after issuing a deposit address.",
    "복사": "Copy",
    "복사 실패": "Copy failed",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "Send only to the displayed {networkLabel} address. Admin direct deposits are also subject to the x3 wagering requirement.",
    "등록 중...": "Registering...",
    "송금 완료 후 충전 확인 요청": "Request Deposit Check After Transfer",
    "Admin Exchange": "Admin Withdrawal",
    "받는 지갑": "Receiving Wallet",
    "환전 받을 USDT TRC20 메인넷 주소": "USDT TRC20 Mainnet address to receive the withdrawal",
    "금액": "Amount",
    "환전 금액": "Withdrawal amount",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "Withdrawal proceeds only after DB asset, verified withdrawable amount, and x3 wagering requirement checks all pass. Operating revenue is not added to personal withdrawable amount.",
    "환전 요청": "Request Withdrawal",
    "최근 결제 요청": "Recent Payment Requests",
    "새로고침": "Refresh",
    "구분": "Type",
    "상태": "Status",
    "주소": "Address",
    "요청ID": "Request ID",
    "관리": "Manage",
    "불러오는 중...": "Loading...",
    "결제 요청 내역이 없습니다.": "No payment requests found.",
    "재확인": "Recheck"
  },
  "ru": {
    "요청 처리 중 오류가 발생했습니다.": "При обработке запроса произошла ошибка.",
    "완료": "Завершено",
    "진행중": "В процессе",
    "검토필요": "Требует проверки",
    "취소": "Отменено",
    "실패": "Ошибка",
    "환전": "Вывод",
    "충전": "Пополнение",
    "USDT TRC20 메인넷": "USDT TRC20 основная сеть",
    "정책 확인 중": "Проверка политики",
    "x3 베팅요건 충족": "Требование x3 по ставкам выполнено",
    "x3 남은 베팅 {amount}": "Осталось ставок x3: {amount}",
    "입금주소 발급 실패": "Не удалось выдать адрес пополнения",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "Адрес пополнения выдан. Отправьте средства на этот адрес и нажмите кнопку завершения.",
    "먼저 입금주소를 발급하세요.": "Сначала выдайте адрес пополнения.",
    "충전 요청 실패": "Запрос пополнения не выполнен",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "Запрос пополнения зарегистрирован. Фактическая сумма будет отражена по ончейн-сумме, подтвержденной мостом.",
    "환전 요청 실패": "Запрос вывода не выполнен",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "Запрос вывода зарегистрирован. Он будет выполнен только после проверки требования x3 и доступной к выводу суммы в БД.",
    "취소 실패": "Не удалось отменить",
    "요청 취소 처리를 보냈습니다.": "Запрос на отмену отправлен.",
    "재확인 실패": "Повторная проверка не выполнена",
    "입금 재확인 요청을 보냈습니다.": "Запрос повторной проверки пополнения отправлен.",
    "어드민 결제": "Платежи администратора",
    "내 자산": "Мои активы",
    "출금가능 검증금액": "Проверенная сумма для вывода",
    "x3 베팅요건": "Требование ставок x3",
    "운영수익 정책": "Политика операционного дохода",
    "개인 출금가능금액에 미가산": "Не добавляется к личной сумме вывода",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "Прямые пополнения администратора фиксируют такое же требование ставок x3, как и у пользователей. Операционный доход, например игровые комиссии, рейк и комиссии, не добавляется к личной сумме вывода администратора и отделяется в отдельный реестр доходов.",
    "결제 네트워크": "Платежная сеть",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "Текущая рабочая среда использует только основную сеть USDT TRC20.",
    "환전하기": "Вывести",
    "충전하기": "Пополнить",
    "Admin Charge": "Пополнение администратора",
    "내 송금 지갑 주소": "Адрес моего кошелька отправки",
    "선택 입력: 내가 송금하는 지갑 주소": "Необязательно: адрес кошелька, с которого я отправляю",
    "예상 금액": "Ожидаемая сумма",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "Необязательно: фактическое зачисление по ончейн-сумме",
    "발급 중...": "Выдается...",
    "입금주소 발급": "Выдать адрес пополнения",
    "입금 지갑 주소": "Адрес кошелька пополнения",
    "입금주소 발급 후 표시됩니다.": "Отображается после выдачи адреса пополнения.",
    "복사": "Копировать",
    "복사 실패": "Не удалось скопировать",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "Отправляйте только на показанный адрес {networkLabel}. Прямые пополнения администратора также подпадают под требование ставок x3.",
    "등록 중...": "Регистрация...",
    "송금 완료 후 충전 확인 요청": "Запросить проверку пополнения после перевода",
    "Admin Exchange": "Вывод администратора",
    "받는 지갑": "Кошелек получателя",
    "환전 받을 USDT TRC20 메인넷 주소": "Адрес основной сети USDT TRC20 для получения вывода",
    "금액": "Сумма",
    "환전 금액": "Сумма вывода",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "Вывод выполняется только после прохождения проверок актива в БД, проверенной суммы вывода и требования ставок x3. Операционный доход не добавляется к личной сумме вывода.",
    "환전 요청": "Запросить вывод",
    "최근 결제 요청": "Последние платежные запросы",
    "새로고침": "Обновить",
    "구분": "Тип",
    "상태": "Статус",
    "주소": "Адрес",
    "요청ID": "ID запроса",
    "관리": "Управление",
    "불러오는 중...": "Загрузка...",
    "결제 요청 내역이 없습니다.": "Платежные запросы отсутствуют.",
    "재확인": "Проверить снова"
  },
  "zh": {
    "요청 처리 중 오류가 발생했습니다.": "处理请求时发生错误。",
    "완료": "已完成",
    "진행중": "进行中",
    "검토필요": "需要审核",
    "취소": "已取消",
    "실패": "失败",
    "환전": "提现",
    "충전": "充值",
    "USDT TRC20 메인넷": "USDT TRC20 主网",
    "정책 확인 중": "正在确认政策",
    "x3 베팅요건 충족": "已满足 x3 投注要求",
    "x3 남은 베팅 {amount}": "x3 剩余投注 {amount}",
    "입금주소 발급 실패": "充值地址发放失败",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "充值地址已发放。请向该地址转账后点击完成按钮。",
    "먼저 입금주소를 발급하세요.": "请先发放充值地址。",
    "충전 요청 실패": "充值请求失败",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "充值请求已登记。实际入账金额将按桥接程序确认的链上金额反映。",
    "환전 요청 실패": "提现请求失败",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "提现请求已登记。仅在通过 x3 要求和 DB 可提现金额验证后处理。",
    "취소 실패": "取消失败",
    "요청 취소 처리를 보냈습니다.": "已发送取消请求。",
    "재확인 실패": "重新确认失败",
    "입금 재확인 요청을 보냈습니다.": "已发送充值重新确认请求。",
    "어드민 결제": "管理员支付",
    "내 자산": "我的资产",
    "출금가능 검증금액": "已验证可提现金额",
    "x3 베팅요건": "x3 投注要求",
    "운영수익 정책": "运营收益政策",
    "개인 출금가능금액에 미가산": "不计入个人可提现金额",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "管理员直接充值与用户一样记录 x3 投注要求。游戏手续费、抽水、佣金等运营收益不会加入管理员个人可提现金额，而是分离到单独收益账本。",
    "결제 네트워크": "支付网络",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "当前正式环境仅使用 USDT TRC20 主网。",
    "환전하기": "提现",
    "충전하기": "充值",
    "Admin Charge": "管理员充值",
    "내 송금 지갑 주소": "我的转出钱包地址",
    "선택 입력: 내가 송금하는 지갑 주소": "可选：我转出的钱包地址",
    "예상 금액": "预计金额",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "可选：实际反映以链上入金金额为准",
    "발급 중...": "发放中...",
    "입금주소 발급": "发放充值地址",
    "입금 지갑 주소": "充值钱包地址",
    "입금주소 발급 후 표시됩니다.": "发放充值地址后显示。",
    "복사": "复制",
    "복사 실패": "复制失败",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "请务必只向显示的 {networkLabel} 地址转账。管理员直接充值也适用 x3 投注要求。",
    "등록 중...": "登记中...",
    "송금 완료 후 충전 확인 요청": "转账完成后请求充值确认",
    "Admin Exchange": "管理员提现",
    "받는 지갑": "接收钱包",
    "환전 받을 USDT TRC20 메인넷 주소": "用于接收提现的 USDT TRC20 主网地址",
    "금액": "金额",
    "환전 금액": "提现金额",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "提现必须同时通过 DB 资产、已验证可提现金额和 x3 投注要求检查后才会处理。运营收益不加入个人可提现金额。",
    "환전 요청": "请求提现",
    "최근 결제 요청": "最近支付请求",
    "새로고침": "刷新",
    "구분": "类型",
    "상태": "状态",
    "주소": "地址",
    "요청ID": "请求ID",
    "관리": "管理",
    "불러오는 중...": "加载中...",
    "결제 요청 내역이 없습니다.": "没有支付请求记录。",
    "재확인": "重新确认"
  },
  "vi": {
    "요청 처리 중 오류가 발생했습니다.": "Đã xảy ra lỗi khi xử lý yêu cầu.",
    "완료": "Hoàn tất",
    "진행중": "Đang xử lý",
    "검토필요": "Cần xem xét",
    "취소": "Đã hủy",
    "실패": "Thất bại",
    "환전": "Rút tiền",
    "충전": "Nạp tiền",
    "USDT TRC20 메인넷": "USDT TRC20 Mainnet",
    "정책 확인 중": "Đang kiểm tra chính sách",
    "x3 베팅요건 충족": "Đã đạt yêu cầu cược x3",
    "x3 남은 베팅 {amount}": "Cược x3 còn lại {amount}",
    "입금주소 발급 실패": "Không thể cấp địa chỉ nạp",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "Địa chỉ nạp đã được cấp. Hãy chuyển tiền đến địa chỉ đó rồi nhấn nút hoàn tất.",
    "먼저 입금주소를 발급하세요.": "Vui lòng cấp địa chỉ nạp trước.",
    "충전 요청 실패": "Yêu cầu nạp tiền thất bại",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "Yêu cầu nạp tiền đã được ghi nhận. Số tiền thực tế sẽ dựa trên số tiền on-chain được bridge xác nhận.",
    "환전 요청 실패": "Yêu cầu rút tiền thất bại",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "Yêu cầu rút tiền đã được ghi nhận. Chỉ xử lý khi vượt qua yêu cầu x3 và kiểm tra số tiền có thể rút trong DB.",
    "취소 실패": "Hủy thất bại",
    "요청 취소 처리를 보냈습니다.": "Đã gửi xử lý hủy yêu cầu.",
    "재확인 실패": "Kiểm tra lại thất bại",
    "입금 재확인 요청을 보냈습니다.": "Đã gửi yêu cầu kiểm tra lại giao dịch nạp.",
    "어드민 결제": "Thanh toán Admin",
    "내 자산": "Tài sản của tôi",
    "출금가능 검증금액": "Số tiền có thể rút đã xác minh",
    "x3 베팅요건": "Yêu cầu cược x3",
    "운영수익 정책": "Chính sách doanh thu vận hành",
    "개인 출금가능금액에 미가산": "Không cộng vào số tiền cá nhân có thể rút",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "Khoản nạp trực tiếp của admin ghi nhận yêu cầu cược x3 giống người dùng. Doanh thu vận hành như phí game, rake và hoa hồng không được cộng vào số tiền cá nhân có thể rút của admin mà được tách sang sổ doanh thu riêng.",
    "결제 네트워크": "Mạng thanh toán",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "Môi trường vận hành hiện chỉ sử dụng USDT TRC20 Mainnet.",
    "환전하기": "Rút tiền",
    "충전하기": "Nạp tiền",
    "Admin Charge": "Nạp tiền Admin",
    "내 송금 지갑 주소": "Địa chỉ ví gửi của tôi",
    "선택 입력: 내가 송금하는 지갑 주소": "Tùy chọn: địa chỉ ví tôi gửi tiền",
    "예상 금액": "Số tiền dự kiến",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "Tùy chọn: số thực tế dựa trên khoản nạp on-chain",
    "발급 중...": "Đang cấp...",
    "입금주소 발급": "Cấp địa chỉ nạp",
    "입금 지갑 주소": "Địa chỉ ví nạp",
    "입금주소 발급 후 표시됩니다.": "Hiển thị sau khi cấp địa chỉ nạp.",
    "복사": "Sao chép",
    "복사 실패": "Sao chép thất bại",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "Chỉ gửi đến địa chỉ {networkLabel} được hiển thị. Khoản nạp trực tiếp của admin cũng áp dụng yêu cầu cược x3.",
    "등록 중...": "Đang đăng ký...",
    "송금 완료 후 충전 확인 요청": "Yêu cầu kiểm tra nạp sau khi chuyển tiền",
    "Admin Exchange": "Rút tiền Admin",
    "받는 지갑": "Ví nhận",
    "환전 받을 USDT TRC20 메인넷 주소": "Địa chỉ USDT TRC20 Mainnet để nhận tiền rút",
    "금액": "Số tiền",
    "환전 금액": "Số tiền rút",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "Rút tiền chỉ xử lý khi vượt qua kiểm tra tài sản DB, số tiền có thể rút đã xác minh và yêu cầu cược x3. Doanh thu vận hành không cộng vào số tiền cá nhân có thể rút.",
    "환전 요청": "Yêu cầu rút tiền",
    "최근 결제 요청": "Yêu cầu thanh toán gần đây",
    "새로고침": "Làm mới",
    "구분": "Loại",
    "상태": "Trạng thái",
    "주소": "Địa chỉ",
    "요청ID": "ID yêu cầu",
    "관리": "Quản lý",
    "불러오는 중...": "Đang tải...",
    "결제 요청 내역이 없습니다.": "Không có yêu cầu thanh toán.",
    "재확인": "Kiểm tra lại"
  },
  "th": {
    "요청 처리 중 오류가 발생했습니다.": "เกิดข้อผิดพลาดระหว่างประมวลผลคำขอ",
    "완료": "เสร็จสิ้น",
    "진행중": "กำลังดำเนินการ",
    "검토필요": "ต้องตรวจสอบ",
    "취소": "ยกเลิกแล้ว",
    "실패": "ล้มเหลว",
    "환전": "ถอนเงิน",
    "충전": "ฝากเงิน",
    "USDT TRC20 메인넷": "USDT TRC20 Mainnet",
    "정책 확인 중": "กำลังตรวจสอบนโยบาย",
    "x3 베팅요건 충족": "ผ่านเงื่อนไขการเดิมพัน x3 แล้ว",
    "x3 남은 베팅 {amount}": "ยอดเดิมพัน x3 ที่เหลือ {amount}",
    "입금주소 발급 실패": "ออกที่อยู่ฝากเงินไม่สำเร็จ",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "ออกที่อยู่ฝากเงินแล้ว กรุณาโอนเงินไปยังที่อยู่นั้นแล้วกดปุ่มเสร็จสิ้น",
    "먼저 입금주소를 발급하세요.": "กรุณาออกที่อยู่ฝากเงินก่อน",
    "충전 요청 실패": "คำขอฝากเงินล้มเหลว",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "บันทึกคำขอฝากเงินแล้ว ยอดเงินจริงจะอ้างอิงจากยอดบนเชนที่บริดจ์ยืนยัน",
    "환전 요청 실패": "คำขอถอนเงินล้มเหลว",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "บันทึกคำขอถอนเงินแล้ว จะดำเนินการเมื่อผ่านเงื่อนไข x3 และการตรวจสอบยอดถอนได้ใน DB เท่านั้น",
    "취소 실패": "ยกเลิกไม่สำเร็จ",
    "요청 취소 처리를 보냈습니다.": "ส่งคำขอยกเลิกแล้ว",
    "재확인 실패": "ตรวจสอบซ้ำไม่สำเร็จ",
    "입금 재확인 요청을 보냈습니다.": "ส่งคำขอตรวจสอบเงินฝากซ้ำแล้ว",
    "어드민 결제": "การชำระเงินแอดมิน",
    "내 자산": "สินทรัพย์ของฉัน",
    "출금가능 검증금액": "ยอดถอนที่ตรวจสอบแล้ว",
    "x3 베팅요건": "เงื่อนไขการเดิมพัน x3",
    "운영수익 정책": "นโยบายรายได้การดำเนินงาน",
    "개인 출금가능금액에 미가산": "ไม่เพิ่มในยอดถอนส่วนบุคคล",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "การฝากโดยตรงของแอดมินจะบันทึกเงื่อนไขการเดิมพัน x3 เหมือนผู้ใช้ รายได้จากการดำเนินงาน เช่น ค่าธรรมเนียมเกม เรค และคอมมิชชัน จะไม่เพิ่มในยอดถอนส่วนบุคคลของแอดมิน แต่แยกไปยังบัญชีรายได้ต่างหาก",
    "결제 네트워크": "เครือข่ายชำระเงิน",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "สภาพแวดล้อมใช้งานจริงปัจจุบันใช้เฉพาะ USDT TRC20 Mainnet",
    "환전하기": "ถอนเงิน",
    "충전하기": "ฝากเงิน",
    "Admin Charge": "ฝากเงินแอดมิน",
    "내 송금 지갑 주소": "ที่อยู่กระเป๋าที่ฉันส่ง",
    "선택 입력: 내가 송금하는 지갑 주소": "ไม่บังคับ: ที่อยู่กระเป๋าที่ฉันใช้ส่ง",
    "예상 금액": "ยอดโดยประมาณ",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "ไม่บังคับ: ยอดจริงอ้างอิงจากยอดฝากบนเชน",
    "발급 중...": "กำลังออก...",
    "입금주소 발급": "ออกที่อยู่ฝากเงิน",
    "입금 지갑 주소": "ที่อยู่กระเป๋าฝากเงิน",
    "입금주소 발급 후 표시됩니다.": "จะแสดงหลังจากออกที่อยู่ฝากเงิน",
    "복사": "คัดลอก",
    "복사 실패": "คัดลอกไม่สำเร็จ",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "กรุณาโอนเฉพาะไปยังที่อยู่ {networkLabel} ที่แสดงเท่านั้น การฝากโดยตรงของแอดมินก็อยู่ภายใต้เงื่อนไขการเดิมพัน x3",
    "등록 중...": "กำลังบันทึก...",
    "송금 완료 후 충전 확인 요청": "ขอตรวจสอบเงินฝากหลังโอนเสร็จ",
    "Admin Exchange": "ถอนเงินแอดมิน",
    "받는 지갑": "กระเป๋ารับเงิน",
    "환전 받을 USDT TRC20 메인넷 주소": "ที่อยู่ USDT TRC20 Mainnet สำหรับรับเงินถอน",
    "금액": "จำนวนเงิน",
    "환전 금액": "ยอดถอน",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "การถอนจะดำเนินการเมื่อผ่านการตรวจสอบสินทรัพย์ DB ยอดถอนที่ตรวจสอบแล้ว และเงื่อนไขการเดิมพัน x3 ทั้งหมด รายได้จากการดำเนินงานจะไม่เพิ่มในยอดถอนส่วนบุคคล",
    "환전 요청": "ขอถอนเงิน",
    "최근 결제 요청": "คำขอชำระเงินล่าสุด",
    "새로고침": "รีเฟรช",
    "구분": "ประเภท",
    "상태": "สถานะ",
    "주소": "ที่อยู่",
    "요청ID": "ID คำขอ",
    "관리": "จัดการ",
    "불러오는 중...": "กำลังโหลด...",
    "결제 요청 내역이 없습니다.": "ไม่มีประวัติคำขอชำระเงิน",
    "재확인": "ตรวจสอบซ้ำ"
  },
  "ja": {
    "요청 처리 중 오류가 발생했습니다.": "リクエスト処理中にエラーが発生しました。",
    "완료": "完了",
    "진행중": "進行中",
    "검토필요": "確認が必要",
    "취소": "キャンセル",
    "실패": "失敗",
    "환전": "出金",
    "충전": "入金",
    "USDT TRC20 메인넷": "USDT TRC20 メインネット",
    "정책 확인 중": "ポリシー確認中",
    "x3 베팅요건 충족": "x3 ベット要件達成",
    "x3 남은 베팅 {amount}": "x3 残りベット {amount}",
    "입금주소 발급 실패": "入金アドレスの発行に失敗しました",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "入金アドレスが発行されました。そのアドレスへ送金後、完了ボタンを押してください。",
    "먼저 입금주소를 발급하세요.": "先に入金アドレスを発行してください。",
    "충전 요청 실패": "入金リクエストに失敗しました",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "入金リクエストが登録されました。実際の反映額はブリッジが確認したオンチェーン金額に基づきます。",
    "환전 요청 실패": "出金リクエストに失敗しました",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "出金リクエストが登録されました。x3 要件とDB出金可能金額の検証を通過した場合のみ進行します。",
    "취소 실패": "キャンセルに失敗しました",
    "요청 취소 처리를 보냈습니다.": "リクエストのキャンセル処理を送信しました。",
    "재확인 실패": "再確認に失敗しました",
    "입금 재확인 요청을 보냈습니다.": "入金の再確認リクエストを送信しました。",
    "어드민 결제": "管理者決済",
    "내 자산": "自分の資産",
    "출금가능 검증금액": "検証済み出金可能金額",
    "x3 베팅요건": "x3 ベット要件",
    "운영수익 정책": "運営収益ポリシー",
    "개인 출금가능금액에 미가산": "個人の出金可能金額には加算されません",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "管理者の直接入金もユーザーと同じく x3 ベット要件を記録します。ゲーム手数料、レーキ、コミッションなどの運営収益は管理者個人の出金可能金額に加算せず、別の収益台帳に分離されます。",
    "결제 네트워크": "決済ネットワーク",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "現在の本番環境では USDT TRC20 メインネットのみ使用します。",
    "환전하기": "出金する",
    "충전하기": "入金する",
    "Admin Charge": "管理者入金",
    "내 송금 지갑 주소": "自分の送金ウォレットアドレス",
    "선택 입력: 내가 송금하는 지갑 주소": "任意入力：自分が送金するウォレットアドレス",
    "예상 금액": "予想金額",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "任意入力：実際の反映はオンチェーン入金額基準",
    "발급 중...": "発行中...",
    "입금주소 발급": "入金アドレス発行",
    "입금 지갑 주소": "入金ウォレットアドレス",
    "입금주소 발급 후 표시됩니다.": "入金アドレス発行後に表示されます。",
    "복사": "コピー",
    "복사 실패": "コピー失敗",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "必ず表示された {networkLabel} アドレスにのみ送金してください。管理者直接入金も x3 ベット要件の対象です。",
    "등록 중...": "登録中...",
    "송금 완료 후 충전 확인 요청": "送金完了後に入金確認をリクエスト",
    "Admin Exchange": "管理者出金",
    "받는 지갑": "受取ウォレット",
    "환전 받을 USDT TRC20 메인넷 주소": "出金を受け取る USDT TRC20 メインネットアドレス",
    "금액": "金額",
    "환전 금액": "出金金額",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "出金はDB資産、検証済み出金可能金額、x3 ベット要件をすべて通過した場合のみ進行します。運営収益は個人の出金可能金額に加算されません。",
    "환전 요청": "出金リクエスト",
    "최근 결제 요청": "最近の決済リクエスト",
    "새로고침": "更新",
    "구분": "区分",
    "상태": "状態",
    "주소": "アドレス",
    "요청ID": "リクエストID",
    "관리": "管理",
    "불러오는 중...": "読み込み中...",
    "결제 요청 내역이 없습니다.": "決済リクエスト履歴がありません。",
    "재확인": "再確認"
  },
  "it": {
    "요청 처리 중 오류가 발생했습니다.": "Si è verificato un errore durante l'elaborazione della richiesta.",
    "완료": "Completato",
    "진행중": "In corso",
    "검토필요": "Richiede revisione",
    "취소": "Annullato",
    "실패": "Non riuscito",
    "환전": "Prelievo",
    "충전": "Deposito",
    "USDT TRC20 메인넷": "USDT TRC20 Mainnet",
    "정책 확인 중": "Verifica policy in corso",
    "x3 베팅요건 충족": "Requisito di puntata x3 soddisfatto",
    "x3 남은 베팅 {amount}": "Puntata x3 rimanente {amount}",
    "입금주소 발급 실패": "Emissione indirizzo di deposito non riuscita",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "L'indirizzo di deposito è stato emesso. Invia i fondi a quell'indirizzo e poi premi il pulsante di completamento.",
    "먼저 입금주소를 발급하세요.": "Emetti prima un indirizzo di deposito.",
    "충전 요청 실패": "Richiesta di deposito non riuscita",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "La richiesta di deposito è stata registrata. L'importo effettivo accreditato sarà basato sull'importo on-chain verificato dal bridge.",
    "환전 요청 실패": "Richiesta di prelievo non riuscita",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "La richiesta di prelievo è stata registrata. Procederà solo dopo il superamento del requisito x3 e della verifica dell'importo prelevabile nel DB.",
    "취소 실패": "Annullamento non riuscito",
    "요청 취소 처리를 보냈습니다.": "La richiesta di annullamento è stata inviata.",
    "재확인 실패": "Ricontrollo non riuscito",
    "입금 재확인 요청을 보냈습니다.": "La richiesta di ricontrollo del deposito è stata inviata.",
    "어드민 결제": "Pagamenti Admin",
    "내 자산": "I miei asset",
    "출금가능 검증금액": "Importo prelevabile verificato",
    "x3 베팅요건": "Requisito di puntata x3",
    "운영수익 정책": "Policy ricavi operativi",
    "개인 출금가능금액에 미가산": "Non aggiunto all'importo personale prelevabile",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "I depositi diretti dell'admin registrano lo stesso requisito di puntata x3 degli utenti. Ricavi operativi come commissioni di gioco, rake e commissioni non vengono aggiunti all'importo personale prelevabile dell'admin e sono separati in un registro ricavi dedicato.",
    "결제 네트워크": "Rete di pagamento",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "L’ambiente di produzione corrente usa solo USDT TRC20 Mainnet.",
    "환전하기": "Preleva",
    "충전하기": "Deposita",
    "Admin Charge": "Deposito Admin",
    "내 송금 지갑 주소": "Indirizzo del mio wallet di invio",
    "선택 입력: 내가 송금하는 지갑 주소": "Opzionale: indirizzo del wallet da cui invio",
    "예상 금액": "Importo stimato",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "Opzionale: l'accredito effettivo si basa sull'importo depositato on-chain",
    "발급 중...": "Emissione...",
    "입금주소 발급": "Emetti indirizzo di deposito",
    "입금 지갑 주소": "Indirizzo wallet di deposito",
    "입금주소 발급 후 표시됩니다.": "Viene mostrato dopo l'emissione dell'indirizzo di deposito.",
    "복사": "Copia",
    "복사 실패": "Copia non riuscita",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "Invia solo all'indirizzo {networkLabel} mostrato. Anche i depositi diretti dell'admin sono soggetti al requisito di puntata x3.",
    "등록 중...": "Registrazione...",
    "송금 완료 후 충전 확인 요청": "Richiedi verifica deposito dopo il trasferimento",
    "Admin Exchange": "Prelievo Admin",
    "받는 지갑": "Wallet di ricezione",
    "환전 받을 USDT TRC20 메인넷 주소": "Indirizzo USDT TRC20 Mainnet per ricevere il prelievo",
    "금액": "Importo",
    "환전 금액": "Importo prelievo",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "Il prelievo procede solo se superano tutti i controlli su asset DB, importo prelevabile verificato e requisito di puntata x3. I ricavi operativi non vengono aggiunti all'importo personale prelevabile.",
    "환전 요청": "Richiedi prelievo",
    "최근 결제 요청": "Richieste di pagamento recenti",
    "새로고침": "Aggiorna",
    "구분": "Tipo",
    "상태": "Stato",
    "주소": "Indirizzo",
    "요청ID": "ID richiesta",
    "관리": "Gestisci",
    "불러오는 중...": "Caricamento...",
    "결제 요청 내역이 없습니다.": "Nessuna richiesta di pagamento trovata.",
    "재확인": "Ricontrolla"
  },
  "fr": {
    "요청 처리 중 오류가 발생했습니다.": "Une erreur s'est produite lors du traitement de la demande.",
    "완료": "Terminé",
    "진행중": "En cours",
    "검토필요": "À vérifier",
    "취소": "Annulé",
    "실패": "Échec",
    "환전": "Retrait",
    "충전": "Dépôt",
    "USDT TRC20 메인넷": "USDT TRC20 Mainnet",
    "정책 확인 중": "Vérification de la politique",
    "x3 베팅요건 충족": "Condition de mise x3 remplie",
    "x3 남은 베팅 {amount}": "Mise x3 restante {amount}",
    "입금주소 발급 실패": "Échec de l'émission de l'adresse de dépôt",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "L'adresse de dépôt a été émise. Envoyez les fonds à cette adresse, puis appuyez sur le bouton de finalisation.",
    "먼저 입금주소를 발급하세요.": "Veuillez d'abord émettre une adresse de dépôt.",
    "충전 요청 실패": "Échec de la demande de dépôt",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "La demande de dépôt a été enregistrée. Le montant crédité réel sera basé sur le montant on-chain vérifié par le bridge.",
    "환전 요청 실패": "Échec de la demande de retrait",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "La demande de retrait a été enregistrée. Elle ne sera traitée qu'après validation de la condition x3 et du montant retirable en DB.",
    "취소 실패": "Échec de l'annulation",
    "요청 취소 처리를 보냈습니다.": "La demande d'annulation a été envoyée.",
    "재확인 실패": "Échec de la revérification",
    "입금 재확인 요청을 보냈습니다.": "La demande de revérification du dépôt a été envoyée.",
    "어드민 결제": "Paiements Admin",
    "내 자산": "Mes actifs",
    "출금가능 검증금액": "Montant retirable vérifié",
    "x3 베팅요건": "Condition de mise x3",
    "운영수익 정책": "Politique de revenus opérationnels",
    "개인 출금가능금액에 미가산": "Non ajouté au montant personnel retirable",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "Les dépôts directs de l'admin enregistrent la même condition de mise x3 que les utilisateurs. Les revenus opérationnels comme les frais de jeu, le rake et les commissions ne sont pas ajoutés au montant personnel retirable de l'admin et sont séparés dans un registre de revenus distinct.",
    "결제 네트워크": "Réseau de paiement",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "L’environnement de production actuel utilise uniquement USDT TRC20 Mainnet.",
    "환전하기": "Retirer",
    "충전하기": "Déposer",
    "Admin Charge": "Dépôt Admin",
    "내 송금 지갑 주소": "Adresse de mon wallet d'envoi",
    "선택 입력: 내가 송금하는 지갑 주소": "Optionnel : adresse du wallet depuis lequel j'envoie",
    "예상 금액": "Montant estimé",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "Optionnel : le crédit réel dépend du montant déposé on-chain",
    "발급 중...": "Émission...",
    "입금주소 발급": "Émettre une adresse de dépôt",
    "입금 지갑 주소": "Adresse du wallet de dépôt",
    "입금주소 발급 후 표시됩니다.": "Affichée après l'émission de l'adresse de dépôt.",
    "복사": "Copier",
    "복사 실패": "Échec de la copie",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "Envoyez uniquement à l'adresse {networkLabel} affichée. Les dépôts directs de l'admin sont aussi soumis à la condition de mise x3.",
    "등록 중...": "Enregistrement...",
    "송금 완료 후 충전 확인 요청": "Demander la vérification du dépôt après transfert",
    "Admin Exchange": "Retrait Admin",
    "받는 지갑": "Wallet de réception",
    "환전 받을 USDT TRC20 메인넷 주소": "Adresse USDT TRC20 Mainnet pour recevoir le retrait",
    "금액": "Montant",
    "환전 금액": "Montant du retrait",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "Le retrait ne se poursuit que si les contrôles de l'actif DB, du montant retirable vérifié et de la condition de mise x3 sont tous validés. Les revenus opérationnels ne sont pas ajoutés au montant personnel retirable.",
    "환전 요청": "Demander un retrait",
    "최근 결제 요청": "Demandes de paiement récentes",
    "새로고침": "Actualiser",
    "구분": "Type",
    "상태": "Statut",
    "주소": "Adresse",
    "요청ID": "ID de demande",
    "관리": "Gestion",
    "불러오는 중...": "Chargement...",
    "결제 요청 내역이 없습니다.": "Aucune demande de paiement.",
    "재확인": "Revérifier"
  },
  "hi": {
    "요청 처리 중 오류가 발생했습니다.": "अनुरोध संसाधित करते समय त्रुटि हुई।",
    "완료": "पूर्ण",
    "진행중": "प्रगति में",
    "검토필요": "समीक्षा आवश्यक",
    "취소": "रद्द",
    "실패": "विफल",
    "환전": "निकासी",
    "충전": "जमा",
    "USDT TRC20 메인넷": "USDT TRC20 मेननेट",
    "정책 확인 중": "नीति जांची जा रही है",
    "x3 베팅요건 충족": "x3 बेटिंग आवश्यकता पूरी हुई",
    "x3 남은 베팅 {amount}": "x3 शेष बेटिंग {amount}",
    "입금주소 발급 실패": "जमा पता जारी करने में विफल",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "जमा पता जारी हो गया है। उस पते पर भेजने के बाद पूर्ण बटन दबाएँ।",
    "먼저 입금주소를 발급하세요.": "पहले जमा पता जारी करें।",
    "충전 요청 실패": "जमा अनुरोध विफल",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "जमा अनुरोध दर्ज हो गया है। वास्तविक क्रेडिट ब्रिज द्वारा सत्यापित ऑन-चेन राशि पर आधारित होगा।",
    "환전 요청 실패": "निकासी अनुरोध विफल",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "निकासी अनुरोध दर्ज हो गया है। यह केवल x3 आवश्यकता और DB निकासी योग्य राशि जांच पास होने पर आगे बढ़ेगा।",
    "취소 실패": "रद्द करना विफल",
    "요청 취소 처리를 보냈습니다.": "अनुरोध रद्द करने की प्रक्रिया भेज दी गई है।",
    "재확인 실패": "पुनः जांच विफल",
    "입금 재확인 요청을 보냈습니다.": "जमा पुनः जांच अनुरोध भेज दिया गया है।",
    "어드민 결제": "एडमिन भुगतान",
    "내 자산": "मेरी संपत्ति",
    "출금가능 검증금액": "सत्यापित निकासी योग्य राशि",
    "x3 베팅요건": "x3 बेटिंग आवश्यकता",
    "운영수익 정책": "संचालन राजस्व नीति",
    "개인 출금가능금액에 미가산": "व्यक्तिगत निकासी योग्य राशि में नहीं जोड़ा जाता",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "एडमिन की सीधी जमा राशि उपयोगकर्ताओं की तरह x3 बेटिंग आवश्यकता दर्ज करती है। गेम फीस, रेक और कमीशन जैसे संचालन राजस्व को एडमिन की व्यक्तिगत निकासी योग्य राशि में नहीं जोड़ा जाता और अलग राजस्व लेजर में रखा जाता है।",
    "결제 네트워크": "भुगतान नेटवर्क",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "वर्तमान प्रोडक्शन वातावरण केवल USDT TRC20 मेननेट का उपयोग करता है।",
    "환전하기": "निकासी",
    "충전하기": "जमा",
    "Admin Charge": "एडमिन जमा",
    "내 송금 지갑 주소": "मेरा भेजने वाला वॉलेट पता",
    "선택 입력: 내가 송금하는 지갑 주소": "वैकल्पिक: वह वॉलेट पता जिससे मैं भेजता हूँ",
    "예상 금액": "अनुमानित राशि",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "वैकल्पिक: वास्तविक क्रेडिट ऑन-चेन जमा राशि पर आधारित है",
    "발급 중...": "जारी हो रहा है...",
    "입금주소 발급": "जमा पता जारी करें",
    "입금 지갑 주소": "जमा वॉलेट पता",
    "입금주소 발급 후 표시됩니다.": "जमा पता जारी होने के बाद दिखेगा।",
    "복사": "कॉपी",
    "복사 실패": "कॉपी विफल",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "केवल दिखाए गए {networkLabel} पते पर भेजें। एडमिन की सीधी जमा पर भी x3 बेटिंग आवश्यकता लागू होती है।",
    "등록 중...": "दर्ज हो रहा है...",
    "송금 완료 후 충전 확인 요청": "ट्रांसफर के बाद जमा जांच अनुरोध",
    "Admin Exchange": "एडमिन निकासी",
    "받는 지갑": "प्राप्त करने वाला वॉलेट",
    "환전 받을 USDT TRC20 메인넷 주소": "निकासी प्राप्त करने के लिए USDT TRC20 मेननेट पता",
    "금액": "राशि",
    "환전 금액": "निकासी राशि",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "निकासी तभी आगे बढ़ती है जब DB संपत्ति, सत्यापित निकासी योग्य राशि और x3 बेटिंग आवश्यकता सभी जांच पास हों। संचालन राजस्व व्यक्तिगत निकासी योग्य राशि में नहीं जोड़ा जाता।",
    "환전 요청": "निकासी अनुरोध",
    "최근 결제 요청": "हाल के भुगतान अनुरोध",
    "새로고침": "रीफ़्रेश",
    "구분": "प्रकार",
    "상태": "स्थिति",
    "주소": "पता",
    "요청ID": "अनुरोध ID",
    "관리": "प्रबंधन",
    "불러오는 중...": "लोड हो रहा है...",
    "결제 요청 내역이 없습니다.": "कोई भुगतान अनुरोध नहीं है।",
    "재확인": "पुनः जांच"
  },
  "ur": {
    "요청 처리 중 오류가 발생했습니다.": "درخواست پر کارروائی کے دوران خرابی ہوئی۔",
    "완료": "مکمل",
    "진행중": "جاری ہے",
    "검토필요": "جائزہ درکار",
    "취소": "منسوخ",
    "실패": "ناکام",
    "환전": "نکلوائیں",
    "충전": "جمع کریں",
    "USDT TRC20 메인넷": "USDT TRC20 مین نیٹ",
    "정책 확인 중": "پالیسی چیک ہو رہی ہے",
    "x3 베팅요건 충족": "x3 بیٹنگ شرط پوری ہوگئی",
    "x3 남은 베팅 {amount}": "x3 باقی بیٹنگ {amount}",
    "입금주소 발급 실패": "ڈپازٹ پتہ جاری کرنے میں ناکامی",
    "입금주소가 발급되었습니다. 해당 주소로 송금 후 완료 버튼을 눌러주세요.": "ڈپازٹ پتہ جاری ہوگیا ہے۔ اس پتے پر رقم بھیجنے کے بعد مکمل بٹن دبائیں۔",
    "먼저 입금주소를 발급하세요.": "پہلے ڈپازٹ پتہ جاری کریں۔",
    "충전 요청 실패": "ڈپازٹ درخواست ناکام",
    "충전 요청이 등록되었습니다. 실제 입금액은 브릿지가 확인한 온체인 금액으로 반영됩니다.": "ڈپازٹ درخواست درج ہوگئی ہے۔ اصل کریڈٹ برج کی تصدیق شدہ آن چین رقم کے مطابق ہوگا۔",
    "환전 요청 실패": "نکلوائی درخواست ناکام",
    "환전 요청이 등록되었습니다. x3 요건과 DB 출금가능금액 검증을 통과한 경우에만 진행됩니다.": "نکلوائی درخواست درج ہوگئی ہے۔ یہ صرف x3 شرط اور DB میں قابل نکلوائی رقم کی تصدیق کے بعد آگے بڑھے گی۔",
    "취소 실패": "منسوخی ناکام",
    "요청 취소 처리를 보냈습니다.": "درخواست منسوخی کی کارروائی بھیج دی گئی ہے۔",
    "재확인 실패": "دوبارہ چیک ناکام",
    "입금 재확인 요청을 보냈습니다.": "ڈپازٹ دوبارہ چیک کی درخواست بھیج دی گئی ہے۔",
    "어드민 결제": "ایڈمن ادائیگی",
    "내 자산": "میرے اثاثے",
    "출금가능 검증금액": "تصدیق شدہ قابل نکلوائی رقم",
    "x3 베팅요건": "x3 بیٹنگ شرط",
    "운영수익 정책": "آپریشنل آمدنی پالیسی",
    "개인 출금가능금액에 미가산": "ذاتی قابل نکلوائی رقم میں شامل نہیں",
    "어드민 직접 충전금은 유저와 동일하게 x3 베팅요건을 기록합니다. 게임 수수료·레이크·커미션 같은 운영수익은 어드민 개인 출금가능금액에 더하지 않고 별도 수익 장부로 분리됩니다.": "ایڈمن کی براہ راست جمع رقم صارفین کی طرح x3 بیٹنگ شرط ریکارڈ کرتی ہے۔ گیم فیس، ریک اور کمیشن جیسی آپریشنل آمدنی ایڈمن کی ذاتی قابل نکلوائی رقم میں شامل نہیں ہوتی بلکہ الگ آمدنی لیجر میں رکھی جاتی ہے۔",
    "결제 네트워크": "ادائیگی نیٹ ورک",
    "현재 운영 환경은 USDT TRC20 메인넷만 사용합니다.": "موجودہ پروڈکشن ماحول صرف USDT TRC20 مین نیٹ استعمال کرتا ہے۔",
    "환전하기": "نکلوائیں",
    "충전하기": "جمع کریں",
    "Admin Charge": "ایڈمن ڈپازٹ",
    "내 송금 지갑 주소": "میرا بھیجنے والا والیٹ پتہ",
    "선택 입력: 내가 송금하는 지갑 주소": "اختیاری: جس والیٹ سے میں بھیجتا ہوں",
    "예상 금액": "متوقع رقم",
    "선택 입력: 실제 반영은 온체인 입금액 기준": "اختیاری: اصل کریڈٹ آن چین ڈپازٹ رقم پر مبنی ہے",
    "발급 중...": "جاری ہو رہا ہے...",
    "입금주소 발급": "ڈپازٹ پتہ جاری کریں",
    "입금 지갑 주소": "ڈپازٹ والیٹ پتہ",
    "입금주소 발급 후 표시됩니다.": "ڈپازٹ پتہ جاری ہونے کے بعد دکھایا جائے گا۔",
    "복사": "کاپی",
    "복사 실패": "کاپی ناکام",
    "반드시 표시된 {networkLabel} 주소로만 송금하세요. 어드민 직접 충전도 x3 베팅요건 대상입니다.": "صرف دکھائے گئے {networkLabel} پتے پر بھیجیں۔ ایڈمن کی براہ راست جمع پر بھی x3 بیٹنگ شرط لاگو ہے۔",
    "등록 중...": "درج ہو رہا ہے...",
    "송금 완료 후 충전 확인 요청": "ٹرانسفر کے بعد ڈپازٹ چیک کی درخواست",
    "Admin Exchange": "ایڈمن نکلوائی",
    "받는 지갑": "وصول کرنے والا والیٹ",
    "환전 받을 USDT TRC20 메인넷 주소": "نکلوائی وصول کرنے کے لیے USDT TRC20 مین نیٹ پتہ",
    "금액": "رقم",
    "환전 금액": "نکلوائی رقم",
    "환전은 DB 자산, 출금가능 검증금액, x3 베팅요건을 모두 통과해야 진행됩니다. 운영수익은 개인 출금가능금액으로 더하지 않습니다.": "نکلوائی صرف تب آگے بڑھے گی جب DB اثاثہ، تصدیق شدہ قابل نکلوائی رقم اور x3 بیٹنگ شرط سب پاس ہوں۔ آپریشنل آمدنی ذاتی قابل نکلوائی رقم میں شامل نہیں ہوتی۔",
    "환전 요청": "نکلوائی درخواست",
    "최근 결제 요청": "حالیہ ادائیگی درخواستیں",
    "새로고침": "ریفریش",
    "구분": "قسم",
    "상태": "حالت",
    "주소": "پتہ",
    "요청ID": "درخواست ID",
    "관리": "انتظام",
    "불러오는 중...": "لوڈ ہو رہا ہے...",
    "결제 요청 내역이 없습니다.": "کوئی ادائیگی درخواست نہیں ہے۔",
    "재확인": "دوبارہ چیک"
  }
};

Object.entries(paymentSupplement).forEach(([lang, table]) => {
  domainSupplement[lang] = { ...(domainSupplement[lang] || {}), ...table };
});

export default domainSupplement;
